import { BetTable, BetField, BetType, Stake, BetTypeInfo } from "./BetStake";
import { Language, Messages } from "../GUI/Language";
import { Constants, effectsVolume, MessageType, virtualWheel } from "../Utils/Constants";
import { BetCompatibility, Bets, PresetType } from "./Bets";
import { BalanceManager, DefaultBalance } from "./BalanceManager";
import { generateSetupFromInit } from "./GameSetup";
import { deepCopy, deepCopyServerBetsArrayToRouletteHistoryArray, GetParameterByName, numToColor } from "../Utils/HelperFunction";
import { GameState } from "./GameState";
import { BalanceUpdate, IMAXAMessageCallback, voidEvent, IMAXAError, lock, IMAXAServerMessage, questionResponse, ChatReceivedMessage, PlayerInfo, TransactionSource, Transaction, PlayboardMode, HistorySnapshot, IMAXALockLevel, IMAXAState, IMAXASubState } from "./Links/IMAXA/IMAXAProtocol"
import { NumberData } from "./GameState";
import { Module } from "../Modules/Module";
import { LuckyNumberJackpot } from "../../../BaseRoulette/Sources/Modules/LuckyNumberJackpot";
import { MESSAGE_SEVERITY_LEVEL } from "@core/GUI/Dialogs/MessageController";
import { Client } from "../Client";
import { RenderListener } from '@core/Logic/RenderListener';
import { MainScene } from "@core/Scenes/MainScene";
import { RouletteHistorySnapshot } from "BaseRoulette/Sources/Logic/Links/IMAXA/IMAXAProtocol";

export enum Phase {
	STARTING_GAME_STATE = 20,
	PREPARING_BALL_STATE = 21,
	BETS_OPEN_STATE = 22,
	BETS_ARE_CLOSING_STATE = 23,
	BALL_OUT_STATE = 24,
	WAITING_WIN_NUMBER_STATE = 30,
	READING_WIN_NUMBER_STATE = 31,
	CLOSING_GAME_STATE = 40,
	BOOT = 0,
	BOOTED = 1,
	CONNECTED = 2,
	BETS_OPEN = 3,
	BETS_CLOSED = 4,
	ERROR_OR_DISCONNECTED = 101010,
	SHOWING_HISTORY_REPLAY = 99999,
	LOCKED = 1337,
	CHANGING_CROUPIER_3 = 2
}

export enum VIDEO_TYPE {
	IMAXA = "imaxaPlayer",
	NANO_COSMOS = "NanoCosmos"
}

export enum BET_CHECKING_MODE {
	NONE = 0,
	TOP = 1,
	BOTTOM = 2,
	LEFT = 3,
	RIGHT = 4
}

export type PresetCoordinate = {
	X : number,
	Y : number,
	A : number
}

export class Logic implements RenderListener {
	public autoRepeatActive: boolean = false;

	public betPresets: Map<string, {fields:Array<PresetCoordinate>,bet:number}>;//what presets are available, what fields do they cover, and bets placed on them

	public playerPlayedFigures: boolean = false;
	public figureBets: Map<number, number> = new Map<number, number>();

	public currentSelectedBetChip: number = 1;
	public maxSelectableBetChipIndex: number = 5;

	public canHurryUp: boolean = true;

	public historyShown: boolean = false;

	public locked = false;
	public lockAnimations = false;
	public canRequestExit: boolean = true;

	// Used for sending the bets once after one second left
	public isEmpty: boolean = true;
	
	public paintModeEnabled: boolean = true;
	public phase: Phase = Phase.BOOT;
	public mainSceneReady: boolean = false;
	public mainSceneActive: boolean = false;
	public mainScene: MainScene;
	public showMoney: boolean = true;
	public showStatistics: boolean = false;
	public jackpotWin = 0;
	public bets: Bets;
	public setup = null;
	public currentGameState: GameState;
	public currentHistorySnapshotIndex = 0;
	public undoRedo: UndoRedo;
	public payoutRequested: boolean = false;
	public modules: Array<Module> = new Array<Module>();//optional game modules, a new one can be loaded at any time upon request
	public h264videoURL = "";
	//For locking the board and track bet placement to avoid invisible bets while orientation warning or lock screen are displayed
	public lockBetting: boolean = false;
	public AsChevalsBet = false;

	public lastWin = 0;
	public storedLastWin = 0;
	public storedLastBet = 0;
	public currentGameSnapshot: RouletteHistorySnapshot;
	public lastGameSnapshot: RouletteHistorySnapshot;

	public balanceManager: BalanceManager;

	public WideBetValue: number = 0;

	public playerPromptsWaiting: number = 0;

	public previousBet: number;

	protected betsCommited: boolean = false;
	protected currentBet: number;
	protected errorData;
	protected lockBuffer: Array<lock> = new Array<lock>();
	protected placeChipSounds = [Constants.SOUNDS.BET_PLACE_SINGLE_1, Constants.SOUNDS.BET_PLACE_SINGLE_2, Constants.SOUNDS.BET_PLACE_SINGLE_3, Constants.SOUNDS.BET_PLACE_SINGLE_4, Constants.SOUNDS.BET_PLACE_SINGLE_5];
	protected audioURL = "";
	protected videoURL = "";
	protected mFunctionMagicRingPending: boolean = false;
	protected mFunctionFinaliPending: boolean = false;
	protected mPickSnakeBetPending = false;
	protected lastChipPlacedSound: number = 0;
	//lateral wide bets
	protected CurrBetX: number = -1;
	protected CurrBetY: number = -1;
	protected lastTimeHistoryClicked: number = 0;
	protected sendBetsImmediateRequested: boolean = false;
	protected sendBetsImmediateRequestedContext: number = 0;
	protected firstSendBetLock: boolean = false;
	protected hadTrackOpenBeforeHistory: boolean = false;
	protected lastWinNumber: number = -1;
	protected defaultBetTypes:BetTypeInfo[]; //bet types that come from init message, bet type multipliers can be overriden by stakes so we need defaults stored

	/*--slot state machine reporting--*/
	public imaxaState: IMAXAState = IMAXAState.IDLE;
	public imaxaSubState: IMAXASubState = IMAXASubState.NONE;
	private previous_imaxaState: IMAXAState | undefined = undefined;
	private previous_imaxaSubState: IMAXASubState | undefined = undefined;
	private flags: Array<String> = new Array<String>();
	/*--------------------------------*/

	private exitingInterval;
	private eraserClicksOnAField = 0
	private eraserClicksOnAFieldBetsPlaced = 0;
	//Do not forget to set it for every action which changes the bets table
	private betsChanged = false
	private ChipCountOrLimitsAllowsBetting: boolean = true;
	//track center presets flag - HARDCODED to match slot virual roulette design
	//pending  stuff
	private mFunctionLateralPending: boolean = false;
	private mFunctionPendingTimer: any;
	private mFunctionPendingTimerInterval: number = 5000;
	private lastEraserSound: number = 0;
	private eraserClearallTimer: any;
	private CavalCoordinatesTrack: number[][] = [[0, 9]/*0*/, [23, 9]/*1*/, [6, 9]/*2*/, [9, 10]/*3*/, [4, 9]/*4*/, [19, 9]/*5*/, [10, 9]/*6*/, [5, 10]/*7*/, [16, 9]/*8*/, [1, 10]/*9*/, [18, 9]/*10*/,
	[14, 9]/*11*/, [7, 10]/*12*/, [12, 9]/*13*/, [25, 9]/*14*/, [2, 9]/*15*/, [21, 9]/*16*/, [8, 9]/*17*/, [3, 10]/*18*/, [3, 9]/*19*/, [24, 9]/*20*/,
	[5, 9]/*21*/, [2, 10]/*22*/, [17, 9]/*23*/, [20, 9]/*24*/, [7, 9]/*25*/, [10, 10]/*26*/, [11, 9]/*27*/, [6, 10]/*28*/, [4, 10]/*29*/, [15, 9]/*30*/,
	[0, 10]/*31*/, [1, 9]/*32*/, [22, 9]/*33*/, [9, 9]/*34*/, [8, 10]/*35*/, [13, 9]/*36*/];
	private CavalCoordinatesTrack00: number[][] = [[0, 9]/*0*/, [18, 9]/*1*/, [11, 10]/*2*/, [14, 9]/*3*/, [7, 10]/*4*/, [10, 9]/*5*/, [3, 10]/*6*/, [6, 9]/*7*/, [25, 9]/*8*/, [2, 9]/*9*/, [21, 9]/*10*/,
	[5, 9]/*11*/, [24, 9]/*12*/, [17, 9]/*13*/, [10, 10]/*14*/, [13, 9]/*15*/, [6, 10]/*16*/, [9, 9]/*17*/, [2, 10]/*18*/, [0, 10]/*19*/, [7, 9]/*20*/,
	[4, 10]/*21*/, [11, 9]/*22*/, [8, 10]/*23*/, [15, 9]/*24*/, [22, 9]/*25*/, [3, 9]/*26*/, [20, 9]/*27*/, [1, 9]/*28*/, [23, 9]/*29*/, [4, 9]/*30*/,
	[1, 10]/*31*/, [8, 9]/*32*/, [5, 10]/*33*/, [12, 9]/*34*/, [9, 10]/*35*/, [16, 9]/*36*/, [19, 9]/*00*/];
	private MagicRingButtons: Array<number> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36];
	private MagicRingButtons00: Array<number> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37];
	private FinaliButtons: Array<number> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

	private sendBetsTimer: any;
	private sendBetsTimerTimeout = 1000

	get maxTableBet(): number {
		return this.bets.CalculateTableMaxWinCredits();
	}

	constructor(public autoplay: boolean = false) {
		Client.remote.OnServerEvent = this.onEvent.bind(this)
		Client.remote.OnInit = this.onInit.bind(this);
		Client.remote.OnError = this.onError.bind(this);

		// Disallow bets on creation and first connect
		Client.game.events.addListener(Constants.EVENTS.SET_WIDE_BET, (index: number) => { this.SetWideBet(index) });

		//Listener for when MainScene is ready to render and can display things such as questions/input and such
		Client.game.events.addListener(Constants.EVENTS.MAIN_SCENE_READY, this.OnMainSceneReady.bind(this));
		Client.game.events.addListener(Constants.EVENTS.MAIN_SCENE_ACTIVE, this.OnMainSceneActive.bind(this));

		Client.game.events.addListener(Constants.EVENTS.BET_SELECTED, (selectedIndex: number) => {
			let selecteValue = this.ChipValues[selectedIndex];
			if (selecteValue == Constants.VALUE_TO_CONSIDER_MAX_BET)
				this.Bet = -1;
			else
				this.Bet = this.ChipValues[selectedIndex];
			this.currentSelectedBetChip = selectedIndex;
		});
		Client.game.events.addListener(Constants.EVENTS.CLEAR_ALL, () => { this.ClearAll(); });
		Client.game.events.addListener(Constants.EVENTS.TOGGLE_SHOW_MONEY, (showMoney: boolean) => { this.showMoney = showMoney; });

		this.phase = Phase.ERROR_OR_DISCONNECTED;
	}

	OnMainSceneReady(mainScene: MainScene): void {
		this.mainSceneReady = true;

		if (virtualWheel) {
			this.onUpdateSendBetsTime(5000);
			this.winNumberReceived(-1);
			this.OnUpdateProgressBar(2000);
			this.onUpdateSendBetsTime(2000);
			this.OnChangePhase(Phase.BETS_OPEN_STATE);
		}
		this.refresh();

		if (this.lockBuffer.length == 0)
			this.handleUnlockEvent(null);
		else
			this.lockBuffer.forEach(lockEvent => {
				this.handleLockEvent(this.lockBuffer.pop());
			});

		Client.game.events.removeListener(Constants.EVENTS.MAIN_SCENE_READY);

		if (Client.slot) {
			this.HandleChangedState(false, IMAXAState.IDLE);
		}
	}

	OnMainSceneActive(mainScene: MainScene): void {
		this.mainSceneActive = true;
		this.mainScene = mainScene;

		if (this.setup != null) {
			mainScene.ProcessSettings();
		}

		if (this.errorData != null && this.phase == Phase.ERROR_OR_DISCONNECTED)
			this.onError("error", this.errorData);

		Client.game.events.emit(Constants.EVENTS.STAKE_CHANGED);
		Client.remote.RemoteActionsHaveChanged();
	}

	public onInit(ok: boolean, msg: IMAXAServerMessage) {
		if (!ok)
			return;

		this.setup = generateSetupFromInit(msg.payload.data);

		this.betsCommited = false;
		this.currentGameState = this.setup.InitialGameState;

		let langCookie = GetParameterByName("locale");
		if (langCookie == "") {
			Language.PreferredLanguage = this.SelectedLanguageID as any
		}

		//parse presets-----
		this.betPresets = new Map<string, { fields: Array<PresetCoordinate>, bet: number }>();

		for (const [key, value] of Object.entries(this.setup.BetPresets)) {
			this.betPresets.set(key, { fields: (value as PresetCoordinate[]), bet: 0 });
		}

		Client.game.events.emit("presetsAssigned", this.betPresets);
		//------------------

		this.bets = new Bets();

		this.balanceManager = new BalanceManager(this.setup.BalanceManagerSetup);
		this.balanceManager.SetCredit(this.currentGameState.Balance);

		this.Bet = this.ChipValues[1];

		this.defaultBetTypes = this.setup.BetTypes;

		if (this.setup.Recovery) {
			this.currentGameSnapshot = deepCopy(this.setup.Recovery);
			this.betPresets = this.currentGameSnapshot.data.betPresets;
			this.CopyBetsToBetTable(this.currentGameSnapshot.data.bets);
			Client.game.events.emit(Constants.EVENTS.PLACE_BET);
		}
		else
			this.currentGameSnapshot = this.newSnapshot();

		if (this.setup.GameHistory.length) {
			this.currentHistorySnapshotIndex = this.setup.GameHistory.length - 1
			this.lastGameSnapshot = deepCopy(this.setup.GameHistory[this.currentHistorySnapshotIndex])
		}

		if (this.setup.playboardMode == PlayboardMode.LESFIGURES_PLUS) {
			this.figureBets = new Map<number, number>();
		}

		this.undoRedo = new UndoRedo(this)

		if (this.setup.videoPlayerSettings.type == VIDEO_TYPE.IMAXA) {
			let imaxaVideoUrl = this.setup.videoPlayerSettings.sources[0].url;
			let imaxaAudioUrl = this.setup.videoPlayerSettings.sources[1].url;
			//cut the provided video url from the server into two , lets say video link arrives as : "nekinekinekineki:80/50" , port 80 is mpeg1 on relay and port 50 is h264 on nginx
			let baseVideoUrl = imaxaVideoUrl.substring(0, imaxaVideoUrl.indexOf(':'));	// "nekinekinekineki"
			let ports = imaxaVideoUrl.substr(imaxaVideoUrl.indexOf(':') + 1, imaxaVideoUrl.length - imaxaVideoUrl.indexOf(':') - 1);// "80/50"
			this.audioURL = imaxaAudioUrl;
			this.videoURL = "wss://" + baseVideoUrl + ":" + ports.substring(0, ports.indexOf('/'));	// wss://nekinekinekineki:80
			this.h264videoURL = "https://" + baseVideoUrl + ":" + ports.substring(ports.indexOf('/') + 1, ports.length - ports.indexOf(':') - 1) + "/";	// https://nekinekinekineki:50/
		}
		
		//account for stake overrides on init aswell if forced stake selection-------------------
		if (this.setup.SelectedStake != -1) {
			//reset bet types to default
			this.bets.betTypes = deepCopy(this.defaultBetTypes);
			//if overrides exist, apply them
			if (this.setup.Stakes[this.setup.SelectedStake].MultiplierOverrides) {
				for (const [key, value] of Object.entries(this.setup.Stakes[this.setup.SelectedStake].MultiplierOverrides)) {
					this.bets.betTypes.forEach(type => {
						if (type.Name.toLocaleLowerCase().replace(/ /g, '') == key.toLocaleLowerCase().replace(/ /g, '')) {
							type.Multiplier = value as number;
						}
					});
				}
			}
		}
		//---------------------------------------------------------------------------------------

		Client.game.events.on("visible", () => {
			if (this.phase != Phase.SHOWING_HISTORY_REPLAY && this.currentGameState.totalTime != 0)
				if (!virtualWheel)
					Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, this.currentGameState.timeLeft / this.currentGameState.totalTime, true)
		})

		if (this.setup.Jackpot.type != null) {
			this.modules.push(new LuckyNumberJackpot());
			Client.game.events.emit(Constants.EVENTS.MODULE_RELOAD);
		}

		if (this.mainSceneActive)
			this.mainScene.ProcessSettings();

		this.refresh();
	}

	public ReloadModules(): void {
		Client.game.events.emit(Constants.EVENTS.MODULE_RELOAD);
	}

	public refresh(): void {
		Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, Messages.WAITING);
		if (this.currentGameState.totalTime != 0 && !virtualWheel)
			Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, this.currentGameState.timeLeft / this.currentGameState.totalTime, true)
		let phase = this.currentGameState.phase;
		this.currentGameState.phase = 0;
		this.OnChangePhase(phase);
		if (this.setup.Recovery) {
			if (!this.setup.Recovery.data) {
				// console.log("ERROR! No gameround data of a recovery round!");
			} else if (this.currentGameState.ID == this.setup.Recovery.data.gameID)
				this.GameRecovery();
		}
	}

	public getCurrentBetsAsArray(): { visible: number, hidden: number }[][] {
		let a: { visible: number, hidden: number }[][] = [];
		this.bets.forEveryPosition((field: BetField, x: number, y: number) => {
			if (!a[x]) a[x] = []
			a[x][y] = { visible: field.BetCredit, hidden: field.HiddenCredit };
		});
		return a;
	}

	protected newSnapshot(): RouletteHistorySnapshot {
		this.betPresets.forEach((value, key) => {
			value.bet = 0;
		});

		let ret = {
			balance: {
				before: this.currentGameState.Balance,
				after: this.currentGameState.Balance
			},
			totalBet: DefaultBalance.ZeroCredits,
			totalWin: DefaultBalance.ZeroCredits,
			startT: Date.now(),
			endT: 0,
			gid: "",
			aid: "",
			host: "",
			data: {
				bets: this.getCurrentBetsAsArray(),
				gameID: this.setup.InitialGameState.ID,
				doubleZero: this.DoubleZero,
				chipValues: this.bets.getStake().ChipValues,
				betPresets: deepCopy(this.betPresets)
			},
			randoms: [],
			void: false,
			transactions: this.currentGameState.Transactions
		}

		return ret;
	}

	protected onEvent(name: string, data: any): void {
		switch (name) {
			case Constants.SERVER_EVENT_NAMES.BET:
				this.currentGameSnapshot.totalBet = data.bet

				if (this.historyShown) {
					this.hideHistoryReplay();
					this.balanceManager.SetCredit(new DefaultBalance(this.currentGameSnapshot.balance.before).Subtract(this.currentGameSnapshot.totalBet));
					Client.game.events.emit(Constants.EVENTS.PANEL_UPDATE_BALANCE, false);
					this.balanceManager.SetCredit(this.currentGameState.Balance);
					Client.game.events.emit(Constants.EVENTS.PANEL_UPDATE_BALANCE);
				}
			break;
			case Constants.SERVER_EVENT_NAMES.HISTORY:
				this.UpdateEntireHistory(data);
				break;
			case Constants.SERVER_EVENT_NAMES.GAME_STATE_CHANGED:
				switch (data.name) {
					case Constants.SERVER_GAME_STATE_CHANGED_TYPES.PHASE:
						this.OnChangePhase(data.new);
						break;
					case Constants.SERVER_GAME_STATE_CHANGED_TYPES.WIN_NUMBER:
						this.winNumberReceived(data.new);
						break;
					case Constants.SERVER_GAME_STATE_CHANGED_TYPES.TOTAL_TIME:
						this.currentGameState.totalTime = data.new;
						this.onUpdateSendBetsTime(this.currentGameState.timeLeft);
						break;
					case Constants.SERVER_GAME_STATE_CHANGED_TYPES.TIME_LEFT:
						this.onUpdateSendBetsTime(data.new);
						break;
					case Constants.SERVER_GAME_STATE_CHANGED_TYPES.GAME_ID:
						this.OnUpdateGameId(data.new);
						break;
					case Constants.SERVER_GAME_STATE_CHANGED_TYPES.LUCKY_LEVEL:
						Client.game.events.emit(Constants.EVENTS.JACKPOT_STATE_LUCKY_LEVEL, data.new);
						break;
					case Constants.SERVER_GAME_STATE_CHANGED_TYPES.LUCKY_NUMBER:
						Client.game.events.emit(Constants.EVENTS.JACKPOT_STATE_LUCKY_NUMBER, data.new);
						break;
				}
				break;
			case Constants.SERVER_EVENT_NAMES.GAME_START:
				this.currentGameSnapshot.gid = data.round.gid;
				break;
			case Constants.SERVER_EVENT_NAMES.GAME_END:
				if (virtualWheel) {
					Client.game.events.emit(Constants.EVENTS.VIRTUAL_GAME_END, data);
				}
				else {
					this.OnGameEndEvent(data);
					Client.remote.RemoteActionsHaveChanged();
				}
				break;
			case Constants.SERVER_EVENT_NAMES.WIN:
				this.OnWinEvent(data);
				break;
			case Constants.SERVER_EVENT_NAMES.BALANCE_UPDATE:
				if (virtualWheel) {
					Client.game.events.emit(Constants.EVENTS.VIRTUAL_DELAY_BALANCE, data);
				}
				else {
					this.handleBalanceUpdateEvent(data);
					Client.remote.RemoteActionsHaveChanged();
				}
				break;
			case Constants.SERVER_EVENT_NAMES.VOID_EVENT:
				let event = { name: "void", data: data } as voidEvent
				this.handleVoidErrorEvent(event)
				break;
			case Constants.SERVER_EVENT_NAMES.AUTHENTICATION_REQUIRED:
				this.handleAuthenticationRequiredEvent(data)
				break;
			case Constants.SERVER_EVENT_NAMES.LOCK:
				if (this.mainSceneReady)
					this.handleLockEvent(data as lock);
				else
					this.lockBuffer.push(data as lock);

				Client.remote.RemoteActionsHaveChanged();
				break;
			case Constants.SERVER_EVENT_NAMES.UNLOCK:
				if (this.mainSceneReady)
					this.handleUnlockEvent(data as lock);
				else {
					const i = this.lockBuffer.findIndex(appliedL => appliedL.reason == (data as lock).reason);
					if (i > -1) {
						this.lockBuffer.splice(i, 1);
					}
				}

				Client.remote.RemoteActionsHaveChanged();
				break;
			case Constants.SERVER_EVENT_NAMES.LOCK_CHANGED:
				this.canRequestExit = true;

				var newLocks:Array<String> = data["new"];
				var oldLocks: Array<String> = data["old"];

				if (!Client.exiting && newLocks.indexOf(IMAXALockLevel.UserClose) != -1 || newLocks.indexOf(IMAXALockLevel.SystemClose) != -1)
					this.GameExit();
				else if (Client.exiting && oldLocks.indexOf(IMAXALockLevel.UserClose) != -1 || oldLocks.indexOf(IMAXALockLevel.SystemClose) != -1)
					this.CancelExit();
				
				break;
			case Constants.SERVER_EVENT_NAMES.SESSION_EXPIRED:
				//??
				break;
			case Constants.SERVER_EVENT_NAMES.STAKE_CHANGED:
				this.bets.stakes[data.id] = new Stake(data.stake);
				this.bets.selectedStake = data.id;

				//reset bet types to default
				this.bets.betTypes = deepCopy(this.defaultBetTypes);

				//if overrides exist, apply them
				if (data.stake.multiplierOverrides) {
					for (const [key, value] of Object.entries(data.stake.multiplierOverrides)) {
						this.bets.betTypes.forEach(type => {
							if (type.Name.toLocaleLowerCase().replace(/ /g,'') == key.toLocaleLowerCase().replace(/ /g,'')) {
								type.Multiplier = value as number;
							}
						});
					}
				}

				Client.game.events.emit(Constants.EVENTS.STAKE_CHANGED);
				Client.remote.RemoteActionsHaveChanged();
				break;
			case Constants.SERVER_EVENT_NAMES.CHAT:
				let message = data as ChatReceivedMessage;
				let foundPlayer = this.setup.PlayerList.find(x => x.id == message.from);
				if (foundPlayer) {
					if (foundPlayer.nickname == '') {
						Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...["Anonymous" + (foundPlayer.number + 1) + ": " + message.msg, MessageType.PLAYER])
					} else {
						Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[foundPlayer.nickname + ": " + message.msg, MessageType.PLAYER])
					}
				}
				break;
			case Constants.SERVER_EVENT_NAMES.PLAYER_JOINED:
				let index = this.setup.PlayerList.findIndex(x => x.id == data.id);
				if (index === -1) {
					if (data.nickname == '') {
						let anonNick = "Anonymous" + (data.number + 1);
						this.setup.PlayerList.push({ id: data.id, nickname: anonNick, number: data.number } as PlayerInfo)
						Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[anonNick + " has joined!", MessageType.PLAYER_STATUS])
					} else {
						this.setup.PlayerList.push(data)
						Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[data.nickname + " has joined!", MessageType.PLAYER_STATUS])
					}
				}
				break;
			case Constants.SERVER_EVENT_NAMES.PLAYER_LEFT:
				if (data.nickname == '') {
					let anonNick = "Anonymous" + (data.number + 1);
					this.setup.PlayerList.push({ id: data.id, nickname: anonNick, number: data.number } as PlayerInfo)
					Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[anonNick + " has left.", MessageType.PLAYER_STATUS])
				} else {
					this.setup.PlayerList.push(data)
					Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[data.nickname + " has left.", MessageType.PLAYER_STATUS])
				}

				let index2 = this.setup.PlayerList.findIndex(x => x.id == data.id);
				if (index2 != -1) {
					this.setup.PlayerList.splice(index2)
				}
				break;
			case Constants.SERVER_EVENT_NAMES.WIN_REPORT:
				Client.game.events.emit(Constants.EVENTS.WIN_REPORT, data)
				break;
			case Constants.SERVER_EVENT_NAMES.JACKPOT_UPDATE:
				Client.game.events.emit(Constants.EVENTS.JACKPOT_UPDATE, data);
				break;
			case Constants.SERVER_EVENT_NAMES.JACKPOT_WAS_WON:
				Client.game.events.emit(Constants.EVENTS.JACKPOT_WAS_WON, data);
				break;
			case Constants.SERVER_EVENT_NAMES.JACKPOT_WON:
				Client.game.events.emit(Constants.EVENTS.JACKPOT_WON, data);
				break;
			case Constants.SERVER_EVENT_NAMES.MESSAGE:
				let duration = 0;
				if (data.displayTime) {
					duration = data.displayTime;
				}
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, data.message, MESSAGE_SEVERITY_LEVEL.NOTICE);
				break;
			default:
				// console.log("Unknown event received! " + name);
				break;
		}
	}

	SubmitQuestionResponse(data: questionResponse): void {
		Client.remote.Send("response", data, (ok: boolean, response: any) => {
			// Not ok and non null response means error from the server
			// Not ok and null response means a timeout
			// In this case (question response) the server response is not needed
			if (!ok && response != null) {
				// console.log(response)
			}
		})
	}

	SubmitChatMessage(message: string, to?: string): void {
		let data = to ? { message: message, to: to } : { message: message }
		Client.remote.SendRequest("chat", data, (ok: boolean, response: any) => {
			if (!ok && response != null) {
				// console.log(response)
			}
		})
	}

	HurryUp(): void {
		if (this.setup.startVoteEnabled && this.canHurryUp && this.Bet > 0) {
			this.canHurryUp = false;
			Client.game.sound.play(Constants.SOUNDS.BUTTON_PRESS, { volume: 0.45 * effectsVolume });
			Client.remote.SendRequest(Constants.CLIENT_REQUESTS.VOTE_START, "", (ok: boolean, response: any) => {
				if (!ok && response != null) {
					console.log(response);
				}
			});
		}
	}

	public handleBalanceUpdateEvent(data: BalanceUpdate): void {
		if (Constants.DEVELOPER_MODE)
			return;

		if (!data)
			return;

		if (data.source == TransactionSource.External) {
			if (this.balanceManager.GetCreditFromArray(data.new) > this.balanceManager.GetCreditFromArray(data.old)) {
				this.balanceManager.SetCredit(data.new)
				Client.game.sound.play(Constants.SOUNDS.PAYIN, { volume: 0.60 * effectsVolume });
			}
			else {
				this.balanceManager.SetCredit(data.new)
				Client.game.sound.play(Constants.SOUNDS.PAYOUT, { volume: 0.60 * effectsVolume });
			}
		}

		let t: Transaction = {
			credits: data.new,
			gid: null,
			id: null,
			result: null,
			source: data.source
		};
		this.currentGameState.Transactions.push(t);

		this.currentGameState.Balance = data.new;
		
		this.balanceManager.SetCredit(data.new);
		Client.game.events.emit(Constants.EVENTS.PANEL_UPDATE_BALANCE);
	}

	private handleVoidErrorEvent(event: voidEvent): void {
		// console.log(event);
		this.ClearAllBetsOnError();
		// Show message from error event
		Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, event.data.message, MESSAGE_SEVERITY_LEVEL.ERROR);
		Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, event.data.message);
		// TODO: BALANCE UPDATE?
		// Update balance from our own client-side 
	}

	private handleAuthenticationRequiredEvent(data: any): void {
		Client.game.events.emit("authEvent", data)
	}

	onError(event: string, imaxaErrorPacket?: IMAXAError): void {
		this.errorData = imaxaErrorPacket;
		this.OnChangePhase(Phase.ERROR_OR_DISCONNECTED);
	}

	protected handleLockEvent(l: lock): void {
		Client.game.events.emit(Constants.EVENTS.ADD_LOCK, l);
	}

	protected handleUnlockEvent(l: lock): void {
		Client.game.events.emit(Constants.EVENTS.REMOVE_LOCK, l);
	}

	get BalanceManager(): BalanceManager {
		return this.balanceManager
	}

	get Credits(): number {
		return this.balanceManager.GetCredit()
	}

	get CurrentWinNumber(): number {
		return this.currentGameState.winNumber
	}

	get CurrentWin(): number {
		return this.lastWin
	}

	get BetsAllowed(): boolean {
		return this.AreBetsOpenInPhase(this.currentGameState.phase) && !this.lockBetting && !this.historyShown && !this.IsSpectator && !this.locked;
	}

	get DoubleZero(): boolean {
		return this.setup.DoubleZero;
	}

	get Bet(): number {
		return this.currentBet
	}

	set Bet(bet: number) {
		if (bet == Client.logic.ChipValues.length) {
			this.currentBet = -1
		} else {
			this.currentBet = bet
		}
	}

	get IsBoard(): boolean {
		return this.boardView;
	}

	set IsBoard(value: boolean) {
		this.boardView = value;
	}

	get ChipValues(): number[] {
		return this.bets.getStake().ChipValues
	}

	get BetFields(): BetField[][] {
		return (this.historyShown && this.lastGameSnapshot) ? this.convertBetsToHistoricBetTable(this.lastGameSnapshot.data.bets) : this.bets.Fields;
	}

	get BetPresets(): Map<string, {fields:Array<PresetCoordinate>,bet:number}> {
		return (this.historyShown && this.lastGameSnapshot) ? this.lastGameSnapshot.data.betPresets : this.betPresets;
	}

	get Phase(): Phase {
		return this.phase
	}

	/**
	 * Orientation warning uses the same call
	 * It will nag a user also in the case of 
	 * Normal bets placed and having historic
	 */
	get BetSum(): number {
		return (this.phase == Phase.SHOWING_HISTORY_REPLAY && this.lastGameSnapshot) ? this.bets.CountFromGivenBetArray(this.lastGameSnapshot.data.bets) : this.bets.Count();
	}

	get IsEmpty(): boolean {
		return this.isEmpty;
	}

	set IsEmpty(value: boolean) {
		this.isEmpty = value;
	}

	get GameID(): number {
		return (this.phase != Phase.SHOWING_HISTORY_REPLAY) ? this.currentGameState.ID : this.lastGameSnapshot.data.gameID;
	}

	get PlayerID(): { Name: string, Nickname: string, Session: string } {
		return this.setup.USER
	}

	get Domain(): string {
		return this.setup.Domain ? this.setup.Domain : ''
	}

	get PayoutEnabled(): boolean {
		return this.setup.USER.PayoutEnabled;
	}

	get LogoutSupported(): boolean {
		return this.setup.USER.LogoutSupported;
	}

	get AuthenticationRequired(): boolean {
		return this.setup.AuthenticationRequired
	}

	get CurrentHistoryNumbers(): Array<number[] | number> {
		return this.currentGameState.HistoryNumbers
	}

	get canHistoryBeViewed(): boolean {
		return !this.IsSpectator && this.currentGameState.phase != Phase.SHOWING_HISTORY_REPLAY && (!this.betsCommited || virtualWheel) && this.lastGameSnapshot && this.lastGameSnapshot.data.gameID != 0;
	}

	get Stake(): Stake {
		return this.bets.getStake()
	}

	get Stream(): { audioURL: string, videoURL: string } {
		return {
			audioURL: this.audioURL,
			videoURL: this.videoURL
		}
	}

	get DefaultAudio(): string {
		return this.setup.DefaultAudio
	}

	get CurrencyValue(): number {
		return this.setup.CurrencyValue
	}

	get HistorySnapshots(): RouletteHistorySnapshot[] {
		return this.setup.GameHistory
	}

	get CurrentHistorySnapshotIndex(): number {
		return this.currentHistorySnapshotIndex
	}

	get IsSpectator(): boolean {
		return this.setup.Spectator;
	}

	set AreBetsAllowedByLimits(value: boolean) {
		if (this.ChipCountOrLimitsAllowsBetting != value) {
			this.ChipCountOrLimitsAllowsBetting = value;

			Client.remote.RemoteActionsHaveChanged();
		}
	}

	get AreBetsAllowedByLimits(): boolean {
		return this.ChipCountOrLimitsAllowsBetting;
	}

	get SelectedLanguageID(): string {
		return this.setup.Locale[0] + this.setup.Locale[1]
	}

	get LastBet(): number {
		return this.storedLastBet
	}

	Finali() {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume })

		let current_number = this.bets.GetNumberFromXY(this.CurrBetX, this.CurrBetY);
		if (BetType.BET_PLAIN != this.bets.getBetType(this.CurrBetX, this.CurrBetY) || 37 == current_number || (this.mFunctionFinaliPending && current_number > 9)/*ce smo oznacili kaj naj izbere in je izbral narobe, nehamo, mora pa funkcija delati v primeru da ima izbrano stevilko od prej */) {
			if (!this.mFunctionFinaliPending) {
				// Reset all hotspots to normal state first!
				Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS);
				Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS);
				//enable winning highlights for choosing
				Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS, this.FinaliButtons, true);
				//add also track!
				Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, this.FinaliButtons, true);
				//disable other hotspot effects
				Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS_EFFECTS, false);
				Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS_EFFECTS, false);
				this.mFunctionFinaliPending = true;
				this.StartPendingTimer();
			}
			else {
				//napacna izbira tipke za dokoncanje funkcije!
				//ce je uporabnik najprej kliknil Finali, in zdaj pritisnil napacno stevilko, potem koncamo
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.WRONG_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);//wrong bet TYPE!
			}
			return;
		}
		this.OnFunctionPendingClear();

		this.undoRedo.AddUndoPoint();

		let x: number;
		let y: number;
		let point = { x: x, y: y }
		this.bets.GetNumberXY(current_number, point);

		// if (current_number != (current_number % 10) || !this.GetCurrentBetField() || this.GetBettingChipValue() == this.GetBetChipIndexFromValue(this.GetCurrentBetField().BetCredit)) //ne postavljamo stave na trenutno polje, ce je ze stava gor ali ni enaka izbranemu cipu
		if (current_number != (current_number % 10) || !this.GetCurrentBetField().BetCredit || this.GetBettingChipValue() == this.GetCurrentBetField().BetCredit) //ne postavljamo stave na trenutno polje, ce je ze stava gor ali ni enaka izbranemu cipu
		{
			this.bets.GetNumberXY(current_number % 10, point);//1-9
			this._PlaceBet(point.x, point.y);
		}
		// if (current_number != ((current_number % 10) + 10) || !this.GetCurrentBetField() || this.GetBettingChipValue() == this.GetBetChipIndexFromValue(this.GetCurrentBetField().BetCredit)) //ne postavljamo stave na trenutno polje, ce je ze stava gor ali ni enaka izbranemu cipu
		if (current_number != ((current_number % 10) + 10) || !this.GetCurrentBetField().BetCredit || this.GetBettingChipValue() == this.GetCurrentBetField().BetCredit) //ne postavljamo stave na trenutno polje, ce je ze stava gor ali ni enaka izbranemu cipu
		{
			this.bets.GetNumberXY((current_number % 10) + 10, point);//10-19
			this._PlaceBet(point.x, point.y);
		}
		// if (current_number != ((current_number % 10) + 20) || !this.GetCurrentBetField() || this.GetBettingChipValue() == this.GetBetChipIndexFromValue(this.GetCurrentBetField().BetCredit)) //ne postavljamo stave na trenutno polje, ce je ze stava gor ali ni enaka izbranemu cipu
		if (current_number != ((current_number % 10) + 20) || !this.GetCurrentBetField().BetCredit || this.GetBettingChipValue() == this.GetCurrentBetField().BetCredit) //ne postavljamo stave na trenutno polje, ce je ze stava gor ali ni enaka izbranemu cipu
		{
			this.bets.GetNumberXY((current_number % 10) + 20, point);//20-29
			this._PlaceBet(point.x, point.y);
		}
		if ((current_number % 10) < 7)//samo do 36
			//if (current_number != ((current_number % 10) + 30) || !this.GetCurrentBetField() || this.GetBettingChipValue() == this.GetBetChipIndexFromValue(this.GetCurrentBetField().BetCredit)) //ne postavljamo stave na trenutno polje, ce je ze stava gor ali ni enaka izbranemu cipu
			if (current_number != ((current_number % 10) + 30) || !this.GetCurrentBetField().BetCredit || this.GetBettingChipValue() == this.GetCurrentBetField().BetCredit) //ne postavljamo stave na trenutno polje, ce je ze stava gor ali ni enaka izbranemu cipu
			{
				this.bets.GetNumberXY((current_number % 10) + 30, point);//30-36
				this._PlaceBet(point.x, point.y);
			}
	}

	MagicRing() {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (!this.IsBoard) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		if (BetType.BET_PLAIN != this.bets.getBetType(this.CurrBetX, this.CurrBetY)) {
			if (!this.mFunctionMagicRingPending) {
				//enable winning highlights for choosing
				Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS, ((this.IsDoubleZero()) ? this.MagicRingButtons00 : this.MagicRingButtons), true);
				//add also track!
				Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, ((this.IsDoubleZero()) ? this.MagicRingButtons00 : this.MagicRingButtons), true);
				//disable other hotspot effects
				Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS_EFFECTS, false);
				Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS_EFFECTS, false);
				this.mFunctionMagicRingPending = true;
				this.StartPendingTimer();
			}
			else {
				//napacna izbira tipke za dokoncanje funkcije!
				//ce je uporabnik najprej kliknil Finali, in zdaj pritisnil napacno stevilko, potem koncamo
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.WRONG_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);//wrong bet TYPE!
			}
			return;
		}
		this.OnFunctionPendingClear();

		let current_number = this.bets.GetNumberFromXY(this.CurrBetX, this.CurrBetY);

		if (0 == current_number || 37 == current_number) {
			this.MaxBet(); //naredimo samo full
			return;
		}

		this.MaxBet(); //naredimo full

		//red, black
		switch (numToColor(current_number)) {//0 == BLACK, 1 == RED, 3 == GREEN
			case 0: this._PlaceBet(11, 7)/*Crna*/; break;
			case 1: this._PlaceBet(15, 7)/*Rdeca*/; break;
			case 3: /*Zelena*/; break;
		}

		//odd-even
		if (current_number % 2)
			this._PlaceBet(19, 7);
		else
			this._PlaceBet(7, 7);

		//1-18, 19-36
		if (current_number < 19)
			this._PlaceBet(3, 7);
		else
			this._PlaceBet(23, 7);

		//1st12, 2nd12, 3rd12
		if (current_number < 13)
			this._PlaceBet(5, 8);
		else if (current_number < 25)
			this._PlaceBet(13, 8);
		else
			this._PlaceBet(21, 8);

		//1st12, 2nd12, 3rd12
		switch (current_number % 3) {
			case 2: this._PlaceBet(25, 3); break; //3,6,9...
			case 1: this._PlaceBet(25, 5); break; //2,5,8...
			case 0: this._PlaceBet(25, 1); break; //1,4,7..
		}

		//pApp->GenerateAction("ToggleTrackMode");//will choose the right one automaticaly
	}

	MaxBet(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume })

		let x = this.CurrBetX;
		let y = this.CurrBetY;

		if (BetType.BET_PLAIN != this.bets.getBetType(x, y)) {
			this.OnFunctionPendingClear();
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.WRONG_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);//wrong bet TYPE!
		}
		this.OnFunctionPendingClear();

		if (BetType.BET_PLAIN == this.bets.getBetType(x, y)) {
			if (0 == x && 3 == y) { //če smo okrog ničle
				if ((this.bets.getBet(x + 1, y - 3) &&
					this.bets.getBet(x + 1, y - 2) &&
					this.bets.getBet(x + 1, y - 1) &&
					this.bets.getBet(x + 1, y) &&
					this.bets.getBet(x + 1, y + 1) &&
					this.bets.getBet(x + 1, y + 2))//&&
					//Bets->getBet(x+1,y+3)
					|| 0 == this.bets.getBet(x, y)//ali ni niti na sredini se stave
				)//ce je ze kronca, potem dodajamo tudi na sredini
					this._PlaceBet(x, y,);
				//this._PlaceBet(x + 1, y - 3,); //leave it commented out, if we will enable it later.
				this._PlaceBet(x + 1, y + 3,); // changed by design to lower row of 0! first row is disabled by design!!!!
				this._PlaceBet(x + 1, y - 2,);
				this._PlaceBet(x + 1, y - 1,);
				this._PlaceBet(x + 1, y);
				this._PlaceBet(x + 1, y + 1);
				this._PlaceBet(x + 1, y + 2);
			}
			else { //vse ostalo
				if (y == 1) //zgornja vrstica
				{
					if ((this.bets.getBet(x - 1, y) &&
						(x == 24 || this.bets.getBet(x + 1, y)) && //ce smo v zadnjem stolpcu ne smemo upostevati 2to1
						this.bets.getBet(x - 1, y + 1) &&
						this.bets.getBet(x, y + 1) &&
						(x == 24 || this.bets.getBet(x + 1, y + 1))) //ce smo v zadnjem stolpcu ne smemo upostevati 2to1
						|| 0 == this.bets.getBet(x, y)//ali ni niti na sredini se stave
					)//ce je ze kronca, potem dodajamo tudi na sredini
						this._PlaceBet(x, y);

					this._PlaceBet(x - 1, y);
					this._PlaceBet(x - 1, y + 1);
					this._PlaceBet(x, y + 1);
					if (x != 24) {
						this._PlaceBet(x + 1, y);
						this._PlaceBet(x + 1, y + 1);
					}
				}
				else if (y == 5) //spodnja vrstica
				{
					if ((this.bets.getBet(x - 1, y - 1) &&
						this.bets.getBet(x, y - 1) &&
						(x == 24 || this.bets.getBet(x + 1, y - 1)) && //ce smo v zadnjem stolpcu ne smemo upostevati 2to1
						this.bets.getBet(x - 1, y) &&
						(x == 24 || this.bets.getBet(x + 1, y))) //ce smo v zadnjem stolpcu ne smemo upostevati 2to1
						|| 0 == this.bets.getBet(x, y)//ali ni niti na sredini se stave
					)//ce je ze kronca, potem dodajamo tudi na sredini
						this._PlaceBet(x, y);
					this._PlaceBet(x - 1, y - 1);
					this._PlaceBet(x, y - 1);
					this._PlaceBet(x - 1, y);

					/*
					this._PlaceBet(x-1,y+1);
					this._PlaceBet(x,y+1);
					this._PlaceBet(x-1,y+1);
					*/

					if (x != 24) {
						this._PlaceBet(x + 1, y);
						this._PlaceBet(x + 1, y - 1);
						//this._PlaceBet(x+1,y+1);               
					}
				}
				else //srednja vrstica
				{
					if ((this.bets.getBet(x - 1, y - 1) &&
						this.bets.getBet(x, y - 1) &&
						(x == 24 || this.bets.getBet(x + 1, y - 1)) && //ce smo v zadnjem stolpcu ne smemo upostevati 2to1
						this.bets.getBet(x - 1, y) &&
						(x == 24 || this.bets.getBet(x + 1, y)) && //ce smo v zadnjem stolpcu ne smemo upostevati 2to1
						this.bets.getBet(x - 1, y + 1) &&
						this.bets.getBet(x, y + 1) &&
						(x == 24 || this.bets.getBet(x + 1, y + 1))) //ce smo v zadnjem stolpcu ne smemo upostevati 2to1
						|| 0 == this.bets.getBet(x, y)//ali ni niti na sredini se stave
					)//ce je ze kronca, potem dodajamo tudi na sredini
						this._PlaceBet(x, y);
					this._PlaceBet(x - 1, y - 1);
					this._PlaceBet(x, y - 1);
					this._PlaceBet(x - 1, y);
					this._PlaceBet(x - 1, y + 1);
					this._PlaceBet(x, y + 1);
					if (x != 24) {
						this._PlaceBet(x + 1, y - 1);
						this._PlaceBet(x + 1, y);
						this._PlaceBet(x + 1, y + 1);
					}
				}
			}
		}
		// pApp->GenerateAction("ToggleTrackMode");//will choose the right one automaticaly
	}

	StartPendingTimer(): void {
		this.mFunctionPendingTimer = setTimeout(() => this.OnFunctionPendingClear(), this.mFunctionPendingTimerInterval, this);
	}

	OnFunctionPendingClear() {
		if (this.mFunctionMagicRingPending)//TODO: dodaj se za ostale pendinge
		{
			//ugasni lucke
			Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS, ((this.IsDoubleZero()) ? this.MagicRingButtons00 : this.MagicRingButtons), false);
			//add also track!
			Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, ((this.IsDoubleZero()) ? this.MagicRingButtons00 : this.MagicRingButtons), false);
			//zresettaj pending spremenljivke
			this.mFunctionMagicRingPending = false;
		}

		if (this.mFunctionFinaliPending) {
			//ugasni lucke
			Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS, this.FinaliButtons, false);
			//add also track!
			Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, this.FinaliButtons, false);
			//zresettaj pending spremenljivke
			this.mFunctionFinaliPending = false;
		}

		if (this.mPickSnakeBetPending) {
			//ugasni lucke
			Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS, ["red", "black"], false);
			// TODO track 
			//add also track!
			// Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, ["red", "black"], false);
			//zresettaj pending spremenljivke
			this.mPickSnakeBetPending = false;
		}

		//set hotspot effects back on
		Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS_EFFECTS, true);
		Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS_EFFECTS, true);

		clearTimeout(this.mFunctionPendingTimer);
	}

	private boardView: boolean = true;
	ToggleTrackView(): void {
		if (!this.BetsAllowed && this.bets.Count() > 0) {
			Client.game.events.emit(Constants.EVENTS.TOGGLE_LAYOUT_SWITCH, false);
			return
		}
		let ok: boolean = false;
		
		if (this.bets.CheckBetsBoardCompatibility() == BetCompatibility.BOTH) {
			Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_TRACK_VIEW);
			ok = true;
		}
		else {
			let str: string = Language.Get(Messages.INCOMPATIBLE_BET);
			str += (this.IsBoard) ? Language.Get(Messages.TO_TRACK_LAYOUT) : Language.Get(Messages.TO_TABLE_LAYOUT);
			// console.log(str);
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, str, MESSAGE_SEVERITY_LEVEL.NOTICE);
			// console.log("Incompatible")
		}
		Client.game.events.emit(Constants.EVENTS.TOGGLE_LAYOUT_SWITCH, ok);
		if (ok) Client.game.sound.play(Constants.SOUNDS.VIEW_CHANGE, { volume: 0.25 * effectsVolume });
	}

	DisplayBoardView(): void {

	}

	public AreBetsOpenInPhase(phase: number): boolean {
		return phase >= 20 && phase < 30 /*&& this.currentGameState.ID != 0*/;
	}

	/*---Vars used in self test developer mode only---*/
	private SelfTest_OncePerGame = true;//makes sure automatic bet placement takes palce only once at open bets
	/*------------------------------------------------*/
	OnChangePhase(phase: Phase) {
		
		let prevPhase;

		if (this.setup != null) {
			// console.log("Phase change! " + this.currentGameState.phase + " => " + phase);
			prevPhase = this.currentGameState.phase;

			if (phase != Phase.SHOWING_HISTORY_REPLAY) {
				this.currentGameState.phase = phase;
			}

			if (this.phase != Phase.SHOWING_HISTORY_REPLAY) {
				Client.game.events.emit(Constants.EVENTS.PHASE_EVENT, phase);

				if ((!this.AreBetsOpenInPhase(prevPhase) || this.historyShown) && this.AreBetsOpenInPhase(phase)) {
					Client.game.events.emit(Constants.EVENTS.BETS_OPENED);
					Client.game.events.emit("FADE_BACKGROUND_MUSIC", true);//to fix switch window audio bug
					this.betsOpen()
				}
			}
		}
		//>20 <30 bets open state
		switch (+phase) {
			case Phase.STARTING_GAME_STATE:
				this.imaxaState = IMAXAState.BETS_CLOSED;
				break;
			case Phase.BOOTED:
				this.imaxaState = IMAXAState.IDLE;
				this.changingCroupier(phase);

				break;
			case Phase.PREPARING_BALL_STATE:
				this.imaxaState = IMAXAState.BETS_OPEN;

			case Phase.BETS_OPEN_STATE:
				this.imaxaState = IMAXAState.BETS_OPEN;
				this.phase = phase;

				if (prevPhase != Phase.SHOWING_HISTORY_REPLAY)
					this.canHurryUp = true;

				Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[Language.Get(Messages.BETS_OPEN_PLACE_BETS), MessageType.SYSTEM]);

				/*---------------If self test is active, randomly places 0->100 bets on the board at random bet open times---------------------*/
				if (this.autoplay && this.SelfTest_OncePerGame && this.Stake) {
					this.SelfTest_OncePerGame = false;

					if (virtualWheel) {
						setTimeout(() => {
							this.PlaceBet(Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_X - 1)), Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_Y - 1)));
							this.PlaceBet(Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_X - 1)), Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_Y - 1)));
							this.PlaceBet(Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_X - 1)), Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_Y - 1)));
							this.PlaceBet(Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_X - 1)), Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_Y - 1)));
							this.PlaceBet(Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_X - 1)), Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_Y - 1)));
						}, 1000);
					}
					else {
						let betsPlaced = Math.floor(Math.random() * 101);
						for (betsPlaced; betsPlaced > 0; betsPlaced--) {
							let randomTime = Math.floor((Math.random() * 10000) - 1000) + 1000;
							setTimeout(() => {
								this.PlaceBet(Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_X - 1)), Math.floor(Math.random() * (BetTable.BETS_TABLE_MAX_Y - 1)));
							}, randomTime);
						}
					}
				}
				/*-----------------------------------------------------------------------------------------------------------------------------*/
				this.ChipCountOrLimitsAllowsBetting = true;

				//console.log("last winnumber : " + this.lastWinNumber);
				if (this.setup.playboardMode == PlayboardMode.LESFIGURES_PLUS && this.playerPlayedFigures && this.lastWinNumber > -1) {
					switch (this.lastWinNumber) {
						case 1:
						case 10:
						case 19:
						case 28:
							{
								if (this.figureBets[0] > 0) {
									//console.log("player won les figures 1");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 1, this.figureBets[0]);
								}
							}
							break;
						case 2:
						case 11:
						case 20:
						case 29:
							{
								if (this.figureBets[1] > 0) {
									//console.log("player won les figures 2");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 2, this.figureBets[1]);
								}
							}
							break;
						case 3:
						case 12:
						case 21:
						case 30:
							{
								if (this.figureBets[2] > 0) {
									//console.log("player won les figures 3");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 3, this.figureBets[2]);
								}
							}
							break;
						case 4:
						case 13:
						case 22:
						case 31:
							{
								if (this.figureBets[3] > 0) {
									//console.log("player won les figures 4");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 4, this.figureBets[3]);
								}
							}
							break;
						case 5:
						case 14:
						case 23:
						case 32:
							{
								if (this.figureBets[4] > 0) {
									//console.log("player won les figures 5");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 5, this.figureBets[4]);
								}
							}
							break;
						case 6:
						case 15:
						case 24:
						case 33:
							{
								if (this.figureBets[5] > 0) {
									//console.log("player won les figures 6");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 6, this.figureBets[5]);
								}
							}
							break;
						case 7:
						case 16:
						case 25:
						case 34:
							{
								if (this.figureBets[6] > 0) {
									//console.log("player won les figures 7");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 7, this.figureBets[6]);
								}
							}
							break;
						case 8:
						case 17:
						case 26:
						case 35:
							{
								if (this.figureBets[7] > 0) {
									//console.log("player won les figures 8");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 8, this.figureBets[7]);
								}
							}
							break;
						case 9:
						case 18:
						case 27:
						case 36:
							{
								if (this.figureBets[8] > 0) {
									//console.log("player won les figures 9");
									Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, 9, this.figureBets[8]);
								}
							}
							break;
					}
					//this.playerPlayedFigures = false;
					this.figureBets = new Map<number, number>();
					this.lastWinNumber = -1;
				}

				if (this.autoRepeatActive) {
					if (this.bets.CountChipsOnPlayboard() == 0 && this.setup.GameHistory.length)
						if (this.BetsAllowed)
							this.RepeatBetsLastGame();
					else {
						this.autoRepeatActive = false;
						Client.game.events.emit(Constants.EVENTS.AUTO_REPEAT);
					}
				}

				break
			case Phase.BETS_ARE_CLOSING_STATE:
				this.imaxaState = IMAXAState.BETS_OPEN;
				this.betsAreClosing()
				this.phase = phase;
				break
			case Phase.BALL_OUT_STATE:
				this.imaxaState = IMAXAState.BETS_OPEN;
				this.phase = phase;
				break
			case Phase.WAITING_WIN_NUMBER_STATE:
				this.imaxaState = IMAXAState.BETS_CLOSED;
				this.canHurryUp = false;
				this.waitingWinNumber();
				this.currentGameState.ID = 0;
				this.phase = phase;
				this.SelfTest_OncePerGame = true;
				Client.game.events.emit(Constants.EVENTS.BETS_CLOSED_TRIGGERED, true);

				if (this.setup.playboardMode == PlayboardMode.LESFIGURES_PLUS) {
					Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, -1, 0);
				}

				break
			case Phase.READING_WIN_NUMBER_STATE:
				this.canHurryUp = false;
				this.readingWinNumber();
				this.phase = phase;
				break
			case Phase.CLOSING_GAME_STATE:
				this.imaxaState = IMAXAState.BETS_CLOSED;
				this.phase = phase;
				break
			case Phase.ERROR_OR_DISCONNECTED:
				this.imaxaState = IMAXAState.ERROR;
				this.phase = phase;
				
				if (this.mainSceneReady) {
					this.ClearAllBetsOnError()

					if (this.Phase != Phase.SHOWING_HISTORY_REPLAY)
						Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, [""]);

					Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, Messages.DISCONNECTED);
					Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, 1.0, true);
					Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS, false, false);
					Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, false, false);

					// To completely hide the video element upon disconnection
					// Client.game.events.emit("hideVideo", true)
					// To switch to silhouette upon disconnection
					Client.game.events.emit("hideVideo", false);

					if (this.setup.playboardMode == PlayboardMode.LESFIGURES_PLUS) {
						Client.game.events.emit(Constants.EVENTS.LES_FIGURES_WIN, -1, 0);
						this.playerPlayedFigures = false;
						this.figureBets = new Map<number, number>();
					}
				}
				break
			case Phase.SHOWING_HISTORY_REPLAY:
				this.imaxaState = IMAXAState.BETS_CLOSED;
				this.phase = phase
				break
			// case Phase.CHANGING_CROUPIER_1:
			// case Phase.CHANGING_CROUPIER_2:
			case Phase.CHANGING_CROUPIER_3:
				this.imaxaState = IMAXAState.BETS_CLOSED;
				this.changingCroupier(phase)
				this.phase = phase
				break
		}

		this.HandleChangedState();
	}

	private changingCroupier(phase: number): void {
		this.bets.ClearAllBets(false, this.playerPlayedFigures);
		this.isEmpty = true;
		this.undoRedo.ClearUndoSnapshots()
		Client.game.events.emit(Constants.EVENTS.PLACE_BET)

		Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, 1.0, true);
		Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS, false, false);
		Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, false, false);

		Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[Language.Get(Messages.CHANGING_CROUPIER), MessageType.SYSTEM])
		Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, Messages.CHANGING_CROUPIER)
		Client.game.events.emit(Constants.EVENTS.WIN_NUMBER, -1)
	}

	PlaceBet(x: number, y: number): void {
		if (this.lockBetting) return
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (!this.bets.checkBet(x, y)) return
		if (!this.bets.Fields[x][y].FieldEnabled) return

		this.SetCurrentBet(x, y);

		this.undoRedo.AddUndoPoint();

		if (this.mFunctionMagicRingPending) {
			this.MagicRing();
			return;
		}

		if (this.mFunctionFinaliPending) {
			this.Finali();
			return;
		}

		if (this.mPickSnakeBetPending) {
			this.PickSnakeBet()
			return
		}
		
		if (this.WideBetValue > 0 && BetType.BET_PLAIN == this.bets.getBetType(x, y)) {
			// A critical bug appears here without this if statement
			if (this.IsBoard) 
				this.WideBetValue = 0
			else {
				this.Lateral(this.WideBetValue, Constants.LATERAL_BET_MODES.LM_CAVALS_TRACK);
				return;
			}
		}

		if (!this._PlaceBet(x, y)) {
			this.undoRedo.ClearLastUndo();
		} else {
			let now = Date.now();
			if (this.Bet != 0 /*&& now > this.lastChipPlacedSound + 25*/) {
				this.lastChipPlacedSound = now;
				Client.game.sound.play(this.placeChipSounds[Math.round(Math.random() * 4)], { volume: 0.8 * effectsVolume });
			}
		}
	}

	_PlaceBet(x: number, y: number, automatic: boolean = false): boolean {
		if (this.lockBetting)
			return false;

		if (y == 0 && x != 26 && x != 27) return false; //we disable first row of bets by design!!!!!!

		if (!automatic && (this.Bet > 0 || this.Bet == -1) && x == 27)//cant manually place bets on taut va , but can erase bets
			return;

		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return false
		}
		if (!this.bets.checkBet(x, y))
			return false
		if (!this.bets.Fields[x][y].FieldEnabled)
			return false

		/* ERASER logic - we ignore hiddenCredits for eraser*/
		if (this.Bet == 0) {
			if (this.eraserClicksOnAField >= 3 || (this.bets.Fields[x][y].BetCredit == 0 && this.eraserClicksOnAFieldBetsPlaced >= 6)) {
				this.Bet = this.ChipValues[1];
				Client.game.events.emit(Constants.EVENTS.BET_SELECTED, 1, true);

				this.eraserClicksOnAField = 0
				this.eraserClicksOnAFieldBetsPlaced = 0
			}
			if (this.bets.Fields[x][y].BetCredit == 0) {
				if (!this.paintModeEnabled || this.bets.Count(true) == 0) this.eraserClicksOnAField++;
				if (!this.paintModeEnabled || this.bets.Count(true) > 0) this.eraserClicksOnAFieldBetsPlaced++;
				return false;
			}
			let now = Date.now();
			if (this.bets.clearBet(x, y) && now > this.lastEraserSound + 25) {
				this.lastEraserSound = now;
				Client.game.sound.play(Constants.SOUNDS.BET_CLEAR_CURRENT, { volume: 0.45 * effectsVolume });
				this.eraserClicksOnAFieldBetsPlaced = 0;
			}
			Client.game.events.emit(Constants.EVENTS.PLACE_BET, [x, y])
			this.SetCurrentBet(-1, -1);
			if (this.bets.Count(true) == 0) this.isEmpty = true
			this.betsChanged = true

			if (!virtualWheel) {
				this.sendBets(false)
			} else {
				Client.game.events.emit(Constants.EVENTS.VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON, this.bets.CountChipsOnPlayboard() > 0);
			}

			return true;
		} else {
			// Prevent switching to first bet chip button bug
			// If eraser was clicked two times, on a bet chip button, place bet
			// Then with eraser on a bet field it would already acknowledge to switch to first chip
			this.eraserClicksOnAField = 0
			this.eraserClicksOnAFieldBetsPlaced = 0

			let betCredit = this.Bet;
			let min = Math.max(1, this.bets.GetMinimalLimit(x, y) - (this.bets.Fields[x][y].BetCredit + this.bets.Fields[x][y].HiddenCredit));
			let max = this.bets.GetMaximalLimit(x, y);
			let creditsLeft = this.balanceManager.GetCredit() - this.bets.Count();

			if (max == 0) {//if field has no max, apply plaboard max
				max = Math.max(0, this.Stake.PlayBoardLimitMax);
			}

			if (betCredit == -1) // max bet
			{
				betCredit = max == 0 ? creditsLeft : max;
			}

			if (max == 0)//limitless bet
			{
				if (betCredit == -1)
					betCredit = creditsLeft;
				else
					betCredit = Math.max(min, this.Bet);
			}
			else
				betCredit = Math.min(Math.max(min, betCredit), max - (this.bets.Fields[x][y].BetCredit + this.bets.Fields[x][y].HiddenCredit));

			if (betCredit == 0 && this.bets.GetMaximalLimit(x, y) != 0) {
				// console.log("Field limit reached!")
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.FIELD_LIMIT), MESSAGE_SEVERITY_LEVEL.NOTICE, false, Client.game.input.activePointer.worldX, Client.game.input.activePointer.worldY);
				return false;
			}

			// not enough credits!
			if (betCredit > creditsLeft) {
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NOT_ENOUGH_CREDITS), MESSAGE_SEVERITY_LEVEL.NOTICE);
				return false;
			}

			betCredit = this.bets.CheckPlayboardLimits(this.bets.Fields[x][y], betCredit);
			if (betCredit == 0) return false;

			this.bets.Fields[x][y].BetCredit += betCredit;
			Client.game.events.emit(Constants.EVENTS.PLACE_BET, [x, y]);
			this.isEmpty = false;
			this.betsChanged = true;

			if (!virtualWheel) {
				this.sendBets(false);
			} else {
				Client.game.events.emit(Constants.EVENTS.VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON, this.bets.CountChipsOnPlayboard() > 0);
			}

			return true;
		}
	}

	Lateral(wideBValue: number, mode: number): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (BetType.BET_PLAIN != this.bets.getBetType(this.CurrBetX, this.CurrBetY)) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.WRONG_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		Client.game.sound.play(this.placeChipSounds[Math.round(Math.random() * 4)], { volume: 0.8 * effectsVolume });

		switch (mode) {
			case Constants.LATERAL_BET_MODES.LM_CAVALS_TRACK:
				if (wideBValue > 10)
					wideBValue = 10;
				for (; wideBValue > 1; wideBValue -= 2)
					this._LateralCavalTrack(wideBValue);
				if (1 == wideBValue)//1 is special case, ker ne moremo dati kavalov, damo polne..
				{
					this._Lateral(wideBValue--);
				}
				this._Lateral(wideBValue);
				break;
			case Constants.LATERAL_BET_MODES.LM_FULL_WIDTH:
				if (wideBValue > 10)
					wideBValue = 10;
				for (let i = wideBValue; i > 0; i--)
					this._Lateral(i);
				break;
			default:
				break;
		}
	}

	_Lateral(width: number): void {
		let x: number = this.CurrBetX;
		let y: number = this.CurrBetY;
		let ix: number = -1;
		let iy: number = -1;
		let index: number = -1;
		let num: number = -1;

		if ((x != -1) && (y != -1) && (BetType.BET_PLAIN != this.bets.getBetType(x, y))) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.WRONG_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		index = this.bets.FindNumberIndex(x, y);
		num = this.bets.GetNumberByIndex(index - width);
		let point = { x: ix, y: iy }
		this.bets.GetNumberXY(num, point);

		if ((point.x != -1) && (point.y != -1) && (BetType.BET_PLAIN == this.bets.getBetType(point.x, point.y)))
			this._PlaceBet(point.x, point.y);

		if (0 == width)
			return;

		num = this.bets.GetNumberByIndex(index + width);
		this.bets.GetNumberXY(num, point);

		if ((point.x != -1) && (point.y != -1) && (BetType.BET_PLAIN == this.bets.getBetType(point.x, point.y)))
			this._PlaceBet(point.x, point.y);

		if (width >= 18)
			return;

		return;
	}

	_LateralCavalTrack(width: number): void {
		let x: number = this.CurrBetX;
		let y: number = this.CurrBetY;
		let ix: number = -1;
		let iy: number = -1;
		let index: number = -1;
		let num: number = -1;

		if ((x != -1) && (y != -1) && (BetType.BET_PLAIN != this.bets.getBetType(x, y))) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.WRONG_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		index = this.bets.FindNumberIndex(x, y);

		if ((num = this.bets.GetNumberByIndex(index - width)) < 0)
			return;

		ix = this.IsDoubleZero() ? this.CavalCoordinatesTrack00[num][0] : this.CavalCoordinatesTrack[num][0];
		iy = this.IsDoubleZero() ? this.CavalCoordinatesTrack00[num][1] : this.CavalCoordinatesTrack[num][1];

		if ((ix != -1) && (iy != -1) && (BetType.BET_CAVAL == this.bets.getBetType(ix, iy)))
			this._PlaceBet(ix, iy);

		if (0 == width)
			return;

		if ((num = this.bets.GetNumberByIndex(index + width - 1)) < 0)
			return;

		ix = this.IsDoubleZero() ? this.CavalCoordinatesTrack00[num][0] : this.CavalCoordinatesTrack[num][0];
		iy = this.IsDoubleZero() ? this.CavalCoordinatesTrack00[num][1] : this.CavalCoordinatesTrack[num][1];

		if ((ix != -1) && (iy != -1) && (BetType.BET_CAVAL == this.bets.getBetType(ix, iy)))
			this._PlaceBet(ix, iy);

		if (width >= 18)
			return;

		return;
	}

	NeighborsBet() {
		Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (this.CurrBetX == -1 && this.CurrBetY == -1) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.WRONG_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		this.Lateral(2, Constants.LATERAL_BET_MODES.LM_FULL_WIDTH);
	}

	SetWideBet(index: number) {
		if (this.WideBetValue != index)
			this.WideBetValue = index;

		return;
	}

	GetBettingChipValue(): number {
		// TODO: return CreditToVirtualCredit(this.BettingChipValue)
		// return this.BettingChipValue
		return this.currentBet
	}

	GetBetChipIndexFromValue(value: number): number {
		return this.ChipValues.indexOf(value)
	}

	public SetBettingChipValue(selectIndex: number): void {
		this.Bet = this.ChipValues[selectIndex];
		Client.game.events.emit(Constants.EVENTS.CLIENT_CHIP_VALUE_CHANGE, selectIndex);
	}

	private ClearAll(): void {
		if (this.BetsAllowed && this.currentGameState.timeLeft > 1000 && !this.isEmpty) {
			// console.log("CLEARALL CALLED");
			this.undoRedo.AddUndoPoint();
			this.bets.ClearAllBets(true);
			Client.game.sound.play(Constants.SOUNDS.BET_CLEAR_ALL, { volume: 0.45 * effectsVolume });
			this.SetCurrentBet(-1, -1);
			this.IsEmpty = true;
			this.betsChanged = true
			if (!virtualWheel) {
				this.sendBets(true)
			}
			clearTimeout(this.eraserClearallTimer);
			this.Bet = this.bets.getStake().ChipValues[1];
			setTimeout(() => {
				Client.game.events.emit(Constants.EVENTS.CLIENT_CHIP_VALUE_CHANGE, 1);
			}, 50);
		}

		if (this.phase != Phase.READING_WIN_NUMBER_STATE)
			Client.game.events.emit(Constants.EVENTS.PLACE_BET);
	}

	RedLeftTrack(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);

		let x: number, y: number
		let point = { x: x, y: y }

		if (this.DoubleZero) {
			this.bets.GetNumberXY(23, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(16, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(21, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(18, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(19, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(12, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
		}
		else {
			this.bets.GetNumberXY(12, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(7, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(18, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(9, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(14, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(1, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
		}
	}

	BlackLeftTrack(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		let x: number, y: number
		let point = { x: x, y: y }

		if (this.DoubleZero) {
			this.bets.GetNumberXY(4, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(33, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(6, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(31, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(8, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(29, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
		}
		else {
			this.bets.GetNumberXY(28, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(29, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(22, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(31, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(20, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(33, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
		}
	}

	RedRightTrack(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		let x: number, y: number
		let point = { x: x, y: y }
		if (this.DoubleZero) {
			this.bets.GetNumberXY(30, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(7, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(32, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(5, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(34, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(3, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
		}
		else {
			this.bets.GetNumberXY(21, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(25, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(34, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(27, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(36, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(30, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
		}
	}

	BlackRightTrack(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		let x: number, y: number
		let point = { x: x, y: y }
		if (this.DoubleZero) {
			this.bets.GetNumberXY(11, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(20, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(17, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(22, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(15, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(24, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
		}
		else {
			this.bets.GetNumberXY(4, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(2, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(17, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(6, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(13, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
			this.bets.GetNumberXY(11, point);
			x = point.x
			y = point.y
			this._PlaceBet(x, y)
		}
	}

	BigSeries(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (0 == this.currentBet)//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });

		this.SetCurrentBet(-1, -1);
		if (this.DoubleZero) {//DOUBLE ZERO GAME - OKROG DOUBLE ZERO
			this._PlaceBet(1, 1)
			this._PlaceBet(2, 5)
			this._PlaceBet(6, 3)
			this._PlaceBet(9, 1)
			this._PlaceBet(9, 5)
			this._PlaceBet(17, 1)
			this._PlaceBet(18, 5)
			this._PlaceBet(20, 3)
			this._PlaceBet(24, 1)
		}
		else {
			this._PlaceBet(1, 2)
			this._PlaceBet(1, 2)
			this._PlaceBet(19, 4)
			this._PlaceBet(19, 4)
			this._PlaceBet(5, 5)
			this._PlaceBet(9, 1)
			this._PlaceBet(13, 1)
			this._PlaceBet(15, 5)
			this._PlaceBet(23, 3)
		}
	}

	Orphans(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		if (this.DoubleZero) {
			this._PlaceBet(4, 2)
			this._PlaceBet(13, 2)
			this._PlaceBet(15, 5)
			this._PlaceBet(22, 2)
			this._PlaceBet(23, 5)
		}
		else {
			this._PlaceBet(2, 5)
			this._PlaceBet(5, 1)
			this._PlaceBet(11, 3)
			this._PlaceBet(13, 3)
			this._PlaceBet(23, 5)
		}
	}

	ZerroGame(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		if (this.DoubleZero) {
			this._PlaceBet(0, 1)
			this._PlaceBet(2, 5)
			this._PlaceBet(9, 5)
			this._PlaceBet(17, 1)
			this._PlaceBet(24, 1)
		}
		else {
			this._PlaceBet(18, 3)
			this._PlaceBet(1, 1)
			this._PlaceBet(9, 1)
			this._PlaceBet(23, 3)
		}
	}

	SmallSeries(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		if (this.DoubleZero) {
			this._PlaceBet(0, 5);
			this._PlaceBet(2, 3);
			this._PlaceBet(5, 5);
			this._PlaceBet(6, 1);
			this._PlaceBet(9, 3);
			this._PlaceBet(12, 5);
			this._PlaceBet(17, 3);
			this._PlaceBet(20, 1);
			this._PlaceBet(20, 5);
			this._PlaceBet(24, 3);
		} else {
			this._PlaceBet(5, 3);
			this._PlaceBet(8, 4);
			this._PlaceBet(11, 5);
			this._PlaceBet(16, 2);
			this._PlaceBet(19, 1);
			this._PlaceBet(23, 1);
		}
	}

	PickSnakeBet(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		if (!this.mPickSnakeBetPending) {
			// Reset all hotspots to normal state first!
			Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS);
			Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS);
			//enable winning highlights for choosing
			Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS, ["red", "black"], true);
			//add also track!
			// Undefined exception because we have not yet setup the red and black hotspots
			// Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, ["red", "black"], true);
			//disable other hotspot effects
			Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS_EFFECTS, false);
			Client.game.events.emit(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS_EFFECTS, false);
			this.mPickSnakeBetPending = true

			this.StartPendingTimer()

			return
		}

		// Valid choices are only:
		// Red x = 15, y = 7
		// Black x = 11, y = 7
		let x = this.CurrBetX
		let y = this.CurrBetY
		if (x != 15 && x != 11 || y != 7) {
			//napacna izbira tipke za dokoncanje funkcije!
			//ce je uporabnik najprej kliknil Finali, in zdaj pritisnil napacno stevilko, potem koncamo
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.WRONG_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);//wrong bet TYPE!
		} else {
			this.OnFunctionPendingClear()
			if (x == 15) this.RedSnake()
			else this.BlackSnake()
		}
	}

	//presets bet placement logic:
	RedSnake(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		let x: number, y: number
		let point = { x: x, y: y }
		this.bets.GetNumberXY(1, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(5, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(9, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(12, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(14, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(16, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(19, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(23, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(27, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(30, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(32, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(34, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)

		this.mPickSnakeBetPending = false
	}

	BlackSnake(): void {
		if (!this.BetsAllowed) {
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		let x: number, y: number
		let point = { x: x, y: y }
		this.bets.GetNumberXY(2, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(6, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(8, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(10, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(13, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(17, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(20, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(24, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(26, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(28, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(31, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(35, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)

		this.mPickSnakeBetPending = false
	}

	RedSplit(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (!this.IsBoard) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		this._PlaceBet(7, 1,) //9-12
		this._PlaceBet(13, 1,) //18-21
		this._PlaceBet(13, 5,) //16-19
		this._PlaceBet(19, 1,) //27-30
	}

	BlackSplit(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}

		if (!this.IsBoard) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);

		this._PlaceBet(7, 3) //8-11
		this._PlaceBet(9, 5) //10-13
		this._PlaceBet(13, 3) //17-20
		this._PlaceBet(19, 3) //26-29
		this._PlaceBet(21, 5) //28-31
	}

	TrackZerroGame() {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);

		if (this.DoubleZero) {
			//TODO: Implement track zero game for doublezero (even n c++ code is TODO!)
		}

		//V c++ kodi je tle se nek AsChevalsBet, ampak logika dela z drugo varjanto implementirano spodaj
		if (this.AsChevalsBet) {
			if (this.DoubleZero) {
				this._PlaceBet(0, 3);
				this._PlaceBet(1, 9);
				this._PlaceBet(3, 9);
				this._PlaceBet(5, 9);
				this._PlaceBet(6, 10);
				this._PlaceBet(8, 10);
				this._PlaceBet(10, 10);
			} else {
				this._PlaceBet(7, 10);
				this._PlaceBet(9, 10);
				this._PlaceBet(0, 3);
				this._PlaceBet(1, 9);
			}
		}
		else {
			this.SetCurrentBet(-1, -1);
			this._PlaceBet(8, 1);
			this._PlaceBet(24, 3);
			this._PlaceBet(2, 1);
			this._PlaceBet(18, 3);
			this._PlaceBet(0, 3);
			this._PlaceBet(22, 3);
			this._PlaceBet(10, 1);
		}
	}

	TrackNassa() {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);

		if (this.AsChevalsBet) {
			if (this.DoubleZero) {
				this._PlaceBet(0, 3);
				this._PlaceBet(1, 9);
				this._PlaceBet(3, 9);
				this._PlaceBet(5, 9);
				this._PlaceBet(6, 10);
				this._PlaceBet(8, 10);
				this._PlaceBet(10, 10);
			} else {
				this._PlaceBet(7, 10);
				this._PlaceBet(9, 10);
				this._PlaceBet(0, 9);
				this._PlaceBet(2, 9);
			}
		}
		else {
			this._PlaceBet(8, 1);
			this._PlaceBet(24, 3);
			this._PlaceBet(2, 1);
			this._PlaceBet(18, 3);
			this._PlaceBet(0, 3);
			this._PlaceBet(22, 3);
			this._PlaceBet(10, 1);
			this._PlaceBet(14, 5);
		}
	}

	TrackOprhans() {
		if (!this.BetsAllowed) {
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);

		if (this.DoubleZero) {
			if (this.AsChevalsBet) {
				this._PlaceBet(4, 10);
				this._PlaceBet(2, 10);
				this._PlaceBet(0, 10);
				this._PlaceBet(7, 9);
				this._PlaceBet(9, 9);
				this._PlaceBet(11, 9);
			}
			else {
				this._PlaceBet(22, 1);
				this._PlaceBet(14, 1);
				this._PlaceBet(4, 1);
				this._PlaceBet(12, 1);
				this._PlaceBet(22, 5);
				this._PlaceBet(14, 5);
				this._PlaceBet(14, 3);
				this._PlaceBet(22, 3);
				this._PlaceBet(12, 3);
				this._PlaceBet(4, 3);
				this._PlaceBet(16, 5);
				this._PlaceBet(24, 5);
			}
		} else {
			if (this.AsChevalsBet) {
				this._PlaceBet(0, 10);
				this._PlaceBet(10, 3);
				this._PlaceBet(23, 9);
				this._PlaceBet(8, 9);
				this._PlaceBet(9, 9);
			}
			else {
				this._PlaceBet(6, 1);
				this._PlaceBet(22, 5);
				this._PlaceBet(10, 3);
				this._PlaceBet(14, 3);
				this._PlaceBet(2, 5);
				this._PlaceBet(12, 3);
				this._PlaceBet(24, 5);
				this._PlaceBet(4, 1);
			}
		}

	}

	HotNumbers(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);

		let x: number;
		let y: number;
		let point = { x: x, y: y }

		for (let index = 0; index < this.currentGameState.HotNumbers.length; index++) {
			this.bets.GetNumberXY(this.currentGameState.HotNumbers[index], point);
			this._PlaceBet(point.x, point.y);
		}
	}

	ColdNumbers(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);

		let x: number;
		let y: number;
		let point = { x: x, y: y }

		for (let index = 0; index < this.currentGameState.ColdNumbers.length; index++) {
			this.bets.GetNumberXY(this.currentGameState.ColdNumbers[index], point);
			this._PlaceBet(point.x, point.y);
		}
	}

	TrackSerie58() {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		if (this.DoubleZero) {
			if (this.AsChevalsBet) {
				this._PlaceBet(13, 9);
				this._PlaceBet(15, 9);
				this._PlaceBet(17, 9);
				this._PlaceBet(0, 1);
				this._PlaceBet(20, 9);
				this._PlaceBet(22, 9);
				this._PlaceBet(24, 9);
			}
			else {
				this._PlaceBet(6, 3);
				this._PlaceBet(8, 1);
				this._PlaceBet(20, 3);
				this._PlaceBet(18, 5);
				this._PlaceBet(8, 5);
				this._PlaceBet(18, 1);
				this._PlaceBet(0, 1);
				this._PlaceBet(2, 5);
				this._PlaceBet(10, 5);
				this._PlaceBet(24, 1);
				this._PlaceBet(16, 1);
				this._PlaceBet(2, 1);
				this._PlaceBet(10, 1);
			}
		}
		else {
			if (this.AsChevalsBet) {
				this._PlaceBet(21, 9);
				this._PlaceBet(19, 9);
				this._PlaceBet(17, 9);
				this._PlaceBet(15, 9);
				this._PlaceBet(13, 9);
				this._PlaceBet(11, 9);
			}
			else {
				this._PlaceBet(22, 1);
				this._PlaceBet(12, 5);
				this._PlaceBet(16, 1);
				this._PlaceBet(4, 3);
				this._PlaceBet(8, 5);
				this._PlaceBet(16, 3);
				this._PlaceBet(6, 3);
				this._PlaceBet(20, 1);
				this._PlaceBet(8, 3);
				this._PlaceBet(24, 1);
				this._PlaceBet(10, 5);
				this._PlaceBet(18, 1);
			}
		}
	}

	TrackBigSeries() {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);
		if (this.DoubleZero) {
			if (this.AsChevalsBet) {
				this._PlaceBet(6, 10);
				this._PlaceBet(8, 10);
				this._PlaceBet(10, 10);
				this._PlaceBet(0, 5);
				this._PlaceBet(1, 9);
				this._PlaceBet(3, 9);
				this._PlaceBet(5, 9);
			}
			else {
				this._PlaceBet(12, 5);
				this._PlaceBet(4, 5);
				this._PlaceBet(16, 3);
				this._PlaceBet(24, 3);
				this._PlaceBet(10, 3);
				this._PlaceBet(2, 3);
				this._PlaceBet(0, 5);
				this._PlaceBet(20, 5);
				this._PlaceBet(6, 1);
				this._PlaceBet(18, 3);
				this._PlaceBet(20, 1);
				this._PlaceBet(8, 3);
				this._PlaceBet(6, 5);
			}
		}
		else {
			if (this.AsChevalsBet) {
				this._PlaceBet(2, 10);
				this._PlaceBet(4, 10);
				this._PlaceBet(6, 10);
				this._PlaceBet(8, 10);
				this._PlaceBet(10, 10);
				this._PlaceBet(0, 9);
				this._PlaceBet(2, 9);
				this._PlaceBet(4, 9);
				this._PlaceBet(6, 9);

			}
			else {
				this._PlaceBet(16, 5);
				this._PlaceBet(12, 1);
				this._PlaceBet(20, 3);
				this._PlaceBet(6, 5);
				this._PlaceBet(20, 5);
				this._PlaceBet(8, 1);
				this._PlaceBet(24, 3);
				this._PlaceBet(2, 1);
				this._PlaceBet(18, 3);
				this._PlaceBet(0, 3);
				this._PlaceBet(22, 3);
				this._PlaceBet(10, 1);
				this._PlaceBet(14, 5);
				this._PlaceBet(4, 5);
				this._PlaceBet(14, 1);
				this._PlaceBet(2, 3);
				this._PlaceBet(18, 5);
			}
		}
	}

	PrisonBets(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return
		}
		if (0 == this.GetBettingChipValue())//ce je izbran cip X, potem ga nastavimo na prvega 
			this.SetBettingChipValue(this.bets.getStake().ChipValues[1]);//izberemo prvi cip

		this.undoRedo.AddUndoPoint();
		Client.game.sound.play(Constants.SOUNDS.BET_PLACE_GROUP, { volume: 0.30 * effectsVolume });
		this.SetCurrentBet(-1, -1);

		let x: number, y: number
		let point = { x: x, y: y }
		this.bets.GetNumberXY(1, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(2, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(3, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(7, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(8, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(9, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(13, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(14, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(15, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(19, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(20, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(21, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(25, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(26, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(27, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(31, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(32, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
		this.bets.GetNumberXY(33, point);
		x = point.x
		y = point.y
		this._PlaceBet(x, y)
	}

	// History must hide prior to repeating the selected game due to bets allowed checks
	HideHistoryAndRepeatSelectedGame(): void {
		this.hideHistoryReplay()
		this.RepeatSelectedGame()
	}

	RepeatSelectedGame(/*index: number*/): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		if (!this.setup.GameHistory.length) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NO_GAME_TO_REPEAT), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		let index = this.currentHistorySnapshotIndex
		let historicSnapshot = this.setup.GameHistory[index]

		if ((this.bets.CountFromGivenBetArray(historicSnapshot.data.bets)) > this.balanceManager.GetCredit()) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NOT_ENOUGH_CREDITS), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		this.undoRedo.AddUndoPoint();

		if (this.bets.CountChipsOnPlayboard() > 0) {
			this.bets.ClearAllBets(true);
		}

		if (this.CopyBetsToBetTable(historicSnapshot.data.bets, true, true)) {//TODO: ignore tautVA bets when doing a copy
			this.betPresets = deepCopy(historicSnapshot.data.betPresets);//also clone presets
			
			this.checkAndToggleBoardView()

			this.betsChanged = true
			Client.game.sound.play(Constants.SOUNDS.BET_REPEAT, { volume: 0.45 * effectsVolume });

			if (!virtualWheel) {
				this.sendBets(true)
			} else {
				Client.game.events.emit(Constants.EVENTS.VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON, this.bets.CountChipsOnPlayboard() > 0);
			}

			Client.game.events.emit(Constants.EVENTS.PLACE_BET)
		} else {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.CANNOT_REPEAT_SELECTED_GAME), MESSAGE_SEVERITY_LEVEL.NOTICE);
		}
	}

	//TODO: Match hiddenCredits to special presets
	RepeatBetsLastGame(): void {
		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		this.undoRedo.AddUndoPoint();

		if (this.bets.CountChipsOnPlayboard(true) == 0) {
			if (!this.setup.GameHistory.length) {
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NO_GAME_TO_REPEAT), MESSAGE_SEVERITY_LEVEL.NOTICE);
				return;
			}
			let latestIndex = this.setup.GameHistory.length - 1
			//repeat
			if ((this.bets.CountFromGivenBetArray(this.setup.GameHistory[latestIndex].data.bets)) > this.balanceManager.GetCredit()) {
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NOT_ENOUGH_CREDITS), MESSAGE_SEVERITY_LEVEL.NOTICE);
				return;
			}

			this.CopyBetsToBetTable(this.setup.GameHistory[latestIndex].data.bets, true, true);
			this.betPresets = deepCopy(this.setup.GameHistory[latestIndex].data.betPresets);//also clone presets
			
			this.checkAndToggleBoardView()
			this.betsChanged = true
			Client.game.sound.play(Constants.SOUNDS.BET_REPEAT, { volume: 0.45 * effectsVolume });
		}
		else {//else double
			let creditsLeft = this.balanceManager.GetCredit() - this.bets.Count();
			let failLevel = 0;

			//attempt to double presets first
			this.betPresets.forEach((value, key) => {
				if(value.bet>0)
					this.PlacePreset((key as PresetType),(value.bet/this.getPresetChipAmount(value.fields)),true);
			});

			this.bets.forEveryPosition((field: BetField, x: number, y: number) => {
				if (x != 27)//ignore taut va, cant double it or repeat
				{
					let betCredit = Math.min(field.BetCredit, creditsLeft);//only double visual credits
					if (betCredit == 0) return;

					if (this.bets.GetMaximalLimit(x, y) > 0)//if we have a limit
						betCredit = Math.min(betCredit, this.bets.GetMaximalLimit(x, y) - (this.bets.Fields[x][y].BetCredit + this.bets.Fields[x][y].HiddenCredit));//but do include hidden credits for limit calculations
						
					if (betCredit == 0) {
						failLevel = Math.max(failLevel, 1);
						Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.FIELD_LIMIT), MESSAGE_SEVERITY_LEVEL.NOTICE, false, Client.game.input.activePointer.worldX, Client.game.input.activePointer.worldY);
						return;
					}

					// not enough credits!
					if (betCredit > creditsLeft) {
						failLevel = Math.max(failLevel, 2);
						return;
					}

					betCredit = this.bets.CheckPlayboardLimits(this.bets.Fields[x][y], betCredit);
					
					if (betCredit == 0) {
						failLevel = Math.max(failLevel, 3);
						return;
					}

					this.betsChanged = true;

					this.bets.Fields[x][y].BetCredit += betCredit
					creditsLeft -= betCredit
				}
			});

			if (this.betsChanged) {
				Client.game.sound.play(Constants.SOUNDS.BET_PLACE_MULTIPLE, { volume: 1.0 * effectsVolume });
			} else {
				if (failLevel == 2) {
					Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NOT_ENOUGH_CREDITS), MESSAGE_SEVERITY_LEVEL.NOTICE);
				}
				this.undoRedo.ClearLastUndo();
			}
		}

		if (!virtualWheel) {
			this.sendBets(true);
		} else {
			Client.game.events.emit(Constants.EVENTS.VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON, this.bets.CountChipsOnPlayboard() > 0);
		}

		Client.game.events.emit(Constants.EVENTS.PLACE_BET);
	}

	CopyPresetsToTable(table: { visible: number, hidden: number }[][], presets: Map<string, { fields: Array<PresetCoordinate>, bet: number }>): void {
		presets.forEach(element => {
			element.fields.forEach(field => {
				table[field.X][field.Y].hidden = element.bet * field.A;
			});
		});
	}

	CopyBetsToBetTable(table:{ visible: number, hidden: number }[][], checkForViolations: boolean = false, playerTriggered:boolean = false): boolean {
		this.isEmpty = true
		let isOK = true;
		let betTable = this.bets.Fields
		let total = 0;
		let totalChips = 0;
		for (let i = 0; i < betTable.length; i++) {
			for (let j = 0; j < betTable[i].length; j++) {
				if(i!=27 || i==27 && !playerTriggered)
				{
					betTable[i][j].BetCredit = table[i][j].visible;
					betTable[i][j].HiddenCredit = table[i][j].hidden;
				}

				if (table[i][j].visible > 0 || table[i][j].hidden > 0) {
					totalChips++;
					total += (table[i][j].visible + table[i][j].hidden);
					this.isEmpty = false;
					if (checkForViolations) {
						if (this.bets.GetMinimalLimit(i, j) > (table[i][j].visible + table[i][j].hidden)) {
							isOK = false;
							break;
						} else if (this.bets.GetMaximalLimit(i, j) && this.bets.GetMaximalLimit(i, j) < (table[i][j].visible + table[i][j].hidden)) {
							isOK = false;
							break;
						}
					}
				}
			}
		}
		if (isOK && checkForViolations) {
			if (this.bets.getStake().BetsCountMax > 0 && totalChips > this.bets.getStake().BetsCountMax) {
				isOK = false;
			} else if (total < this.bets.getStake().PlayBoardLimitMin) {
				isOK = false;
			} else if (this.bets.getStake().PlayBoardLimitMax > 0 && total > this.bets.getStake().PlayBoardLimitMax) {
				isOK = false;
			} else if (this.bets.getStake().MaxTableWinLimit > 0 && this.bets.CalculateTableMaxWinCredits() > this.bets.getStake().MaxTableWinLimit) {
				isOK = false;
			}
		}

		if (!isOK) {
			this.ClearAllBetsOnError();
		}
		return isOK;
	}

	public UndoAction(): void {
		if (this.BetsAllowed) {
			if (this.undoRedo.Undo()) {
				Client.game.sound.play(Constants.SOUNDS.BET_CLEAR_CURRENT, { volume: 0.45 * effectsVolume });
				Client.game.events.emit(Constants.EVENTS.PLACE_BET, [0, 0])
				this.betsChanged = true
				if (!virtualWheel) {
					this.sendBets(false)
				} else {
					Client.game.events.emit(Constants.EVENTS.VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON, this.bets.CountChipsOnPlayboard() > 0);
				}
			}
		}
	}

	CalculateSimulatedWins(): Array<NumberData> {
		let numbersCount: NumberData[] = new Array<NumberData>(this.DoubleZero ? 38 : 37)
		for (let n = 0; n < numbersCount.length; n++) numbersCount[n] = { num: n, count: this.bets.calculateWins(n, true) }
		return numbersCount
	}

	CalculateWinNumberStatistics(): Array<NumberData> {
		let numbersCount: NumberData[] = new Array<NumberData>(this.DoubleZero ? 38 : 37);
		//initial fill of 0's
		for (let n = 0; n < numbersCount.length; n++) numbersCount[n] = { num: n, count: 0 };
		//count how many times each number has fallen and put counters in new array which index is the number representing its count
		this.CurrentHistoryNumbers.forEach(element => {
			let currentNum: NumberData;
			if ((element as number[]).length) {
				currentNum = numbersCount.find(el => el.num == element[1])
				if (currentNum)
					currentNum.count++;
			} else {
				let currentNum = numbersCount[(element as number)];
				currentNum.count++;
			}
		});
		return numbersCount;
	}

	update(time: number, delta: number): void {
		if (!this.mainSceneReady)
			return;

		if (this.currentGameState.timeLeft > 0 && this.phase >= 20 && this.phase < 30) {
			this.currentGameState.timeLeft -= Client.game.loop.rawDelta;

			if (this.currentGameState.timeLeft < 0)
				this.currentGameState.timeLeft = 0;


			if (this.phase == Phase.SHOWING_HISTORY_REPLAY)
				return;

			if ((Client.exiting || (this.currentGameState.timeLeft <= 1000 && !this.firstSendBetLock)) && !virtualWheel) {
				this.sendBets(true);
				this.firstSendBetLock = true;
			}
		}

		if (!virtualWheel)
			this.OnUpdateProgressBar(this.currentGameState.timeLeft);
	}

	protected betsOpen(): void {
		this.sendBetsImmediateRequested = false;
		this.sendBetsImmediateRequestedContext = 0;

		Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, Messages.BETS_OPEN_PLACE_BETS);
		//clear chips from board!

		// For recovery: but definitely not if(this.currentGameState.ID != this.historicGameState.GameID)

		Client.game.events.emit(Constants.EVENTS.PANEL_UPDATE_BALANCE)
		//we added an IF statement inside the timeout to check if in between the call and timeout history replay was clicked.

		//setTimeout(() => { if (this.phase != Phase.SHOWING_HISTORY_REPLAY) this.lastWin = 0; }, 5000)

		// Client.game.events.emit(Constants.EVENTS.VIDEO_ZOOM_IN, -1)
		Client.game.events.emit(Constants.EVENTS.CLOSE_FORCED_MESSAGE_BOX);
		this.firstSendBetLock = false;
		// For recovery: but definitely not if(this.currentGameState.ID != this.historicGameState.GameID)
		// websocket get balance, bets
	}

	private betsAreClosing(): void {
		// // console.log("Bets open state")
		if (this.Phase != Phase.SHOWING_HISTORY_REPLAY)
			Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, [""]);
		Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, Messages.BETS_CLOSING_HURRY)
		Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[Language.Get(Messages.BETS_CLOSING_HURRY), MessageType.SYSTEM])
		// websocket get balance, bets
	}

	/*
	when we chip paint last second, send first bet immediately, wait for server response on said bet placed,
	chip paint into buffer until we get a response, on response send buffer and repeat. Attempt at fixing last
	second chip paint spam and ban on server.
	*/
	public sendBets(immediate?: boolean, sendEmpty: boolean = false): void {
		if (!this.betsChanged && !sendEmpty)
			return;
		if (this.historyShown)
			return;

		immediate = immediate || (this.currentGameState.timeLeft > 0 && this.currentGameState.timeLeft <= 3000)/* || Client.slot*/;

		if (this.BetsAllowed) {

			let presets = {};
			if (this.betPresets && this.betPresets.size > 0)
				this.betPresets.forEach((value, key) => {
					if (value.bet > 0)
						presets[key] = value.bet / this.getPresetChipAmount(value.fields); //we send to server bet per field, while locally we store total bet
				});

			if (!immediate) {
				if (this.sendBetsTimer) clearTimeout(this.sendBetsTimer)
				this.sendBetsTimer = setTimeout(() => {
					// console.log("Sending bets from a timeout " + this.sendBetsTimerTimeout + "ms!")
					this.betsChanged = false
					let b = this.GetBets();
					Client.remote.SendRequest(Constants.CLIENT_REQUESTS.COMMIT_BETS, { bets: b, gameID: this.currentGameState.ID, betPresets: presets }, this.OnCommitBets)
					//console.log(JSON.stringify({ bets: b, gameID: this.currentGameState.ID, betPresets: presets }));
				}, Math.min(this.sendBetsTimerTimeout, this.currentGameState.timeLeft - 1000), this);
			} else if (!this.sendBetsImmediateRequested || sendEmpty) {
				this.betsChanged = false
				this.sendBetsImmediateRequested = true;
				let b = this.GetBets();
				if (virtualWheel) {
					Client.remote.SendRequest(Constants.CLIENT_REQUESTS.COMMIT_BETS, { bets: b, betPresets: presets }, this.OnCommitBets)
					//console.log(JSON.stringify({ bets: b, betPresets: presets }));
				}
				else {
					this.sendBetsImmediateRequestedContext = Client.remote.SendRequest(Constants.CLIENT_REQUESTS.COMMIT_BETS, { bets: b, gameID: this.currentGameState.ID , betPresets: presets }, this.OnCommitBets)
					//console.log(JSON.stringify({ bets: b, gameID: this.currentGameState.ID, betPresets: presets }));
				}
			}
		} else {
			if (this.betsCommited) {
				this.betPresets = this.currentGameSnapshot.data.betPresets;
				this.CopyBetsToBetTable(this.currentGameSnapshot.data.bets);
				Client.game.events.emit(Constants.EVENTS.PLACE_BET);
			}
			else
				this.ClearAllBetsOnError();

			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);  //user visible error
			// console.log("Trying to commit bets outside bets allowed!")
			this.betsChanged = false
		}
	}

	private GetBets(): any[] {
		let b = []
		this.bets.forEveryPosition((field: BetField, x: number, y: number) => {
			if (field.BetCredit > 0) {
				b.push({ X: x, Y: y, amount: field.BetCredit })
			}
		});
		return b;
	}

	private historicBetTable: BetField[][]
	private convertBetsToHistoricBetTable(table: { visible: number, hidden: number }[][]): BetField[][] {
		if (!this.historicBetTable) {
			this.historicBetTable = []
			for (let i = 0; i < BetTable.BETS_TABLE_MAX_X; i++) {
				this.historicBetTable[i] = []
				for (let j = 0; j < BetTable.BETS_TABLE_MAX_Y; j++) {
					this.historicBetTable[i][j] = new BetField(this.bets.Fields[i][j].Info);
				}
			}
		}
		for (let i = 0; i < BetTable.BETS_TABLE_MAX_X; i++) {
			for (let j = 0; j < BetTable.BETS_TABLE_MAX_Y; j++) {
				this.historicBetTable[i][j].BetCredit = table[i][j].visible;
				this.historicBetTable[i][j].HiddenCredit = table[i][j].hidden;
			}
		}
		return this.historicBetTable
	}

	private waitingWinNumber(): void {
		if (this.phase != Phase.WAITING_WIN_NUMBER_STATE && this.mainSceneActive)
			Client.game.sound.play(Constants.SOUNDS.BETS_CLOSED, { volume: 0.30 * effectsVolume });

		if (!virtualWheel && !this.betsCommited && this.bets.Count() > 0) {
			this.ClearAllBetsOnError();
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_NOT_COMMITED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[Language.Get(Messages.BETS_NOT_COMMITED), MessageType.SYSTEM])
		}

		Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, Messages.WAITING_WIN_NUMBER)
		Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[Language.Get(Messages.WAITING_WIN_NUMBER), MessageType.SYSTEM])
		Client.game.events.emit(Constants.EVENTS.VIDEO_ZOOM_IN, 0.5)
	}

	private readingWinNumber(): void {
	}

	public winNumberReceived(winNumber: number): void {
		// console.log("Win number new: " + winNumber);
		this.currentGameState.winNumber = winNumber;
		if (winNumber == -1) {
			this.currentGameSnapshot.randoms = []

			// Clear it for finali and other preset functions
			this.CurrBetX = -1;
			this.CurrBetY = -1;

			// Clear eraser clicks
			this.eraserClicksOnAField = 0;
			this.eraserClicksOnAFieldBetsPlaced = 0;
		} else {
			this.currentGameSnapshot.randoms = [winNumber];
		}

		if (this.phase == Phase.SHOWING_HISTORY_REPLAY) {
			// Must be here otherwise the video will not zoom back
			// While the player is viewing the history replay view
			Client.game.events.emit(Constants.EVENTS.VIDEO_ZOOM_IN, -1)
		}

		if (winNumber != -1) {
			this.lastWinNumber = winNumber;

			//send result with or without win flag
			this.imaxaState = IMAXAState.RESULT;

			if (this.phase != Phase.SHOWING_HISTORY_REPLAY)
				Client.game.events.emit(Constants.EVENTS.WIN_NUMBER, winNumber);
			let winText = this.generateWinNumberText(winNumber);
			Client.game.events.emit(Constants.EVENTS.CHAT_MESSAGE, ...[winText, MessageType.SYSTEM_IMPORTANT]);//pop win number in chat
			Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, winText);//pop win number in system text
			Client.game.events.emit(Constants.EVENTS.VIDEO_ZOOM_IN, -1);


			if (this.BetSum > 0) {
				this.storedLastWin = this.bets.Calculate(winNumber);
				if (this.Phase != Phase.SHOWING_HISTORY_REPLAY)
					this.lastWin = this.storedLastWin;

				//if something was won , send PresentWins state with flag win
				this.UpdateFlags(true, "win", false);
				this.HandleChangedState();//send result state, win flag will be added
				setTimeout(() => {//wait a bit then send present_win as the animation starts playing
					this.imaxaState = IMAXAState.PRESENT_WIN;
					this.HandleChangedState();
				}, 500);
			} else
				this.HandleChangedState();//send result state with no win flag

			let historyNum: number[] = [this.currentGameSnapshot.data.gameID, winNumber];
			this.AddNumberToHistory(historyNum);

			// Uncomment to play Constants.SOUNDS on bets placed without win
			// if(this.bets.Count() > 0 && this.lastWin == 0) Client.game.sound.play(Constants.SOUNDS.CHIPS_DROPS, Constants.SOUNDS.CONFIGS.CHIPS_DROPS)
		}
		this.currentGameState.winNumber = winNumber;

	}

	generateWinNumberText(winNumber: number): string {
		let str = Language.Get(Messages.WINNING_NUMBER_IS);
		str += winNumber == 37 ? "00" : winNumber.toString();
		str += "!";
		return str;
	}

	public NextHistorySnapshot(): void {
		if (this.setup.GameHistory.length == 0) return

		if (this.currentHistorySnapshotIndex == 0) this.currentHistorySnapshotIndex = 0
		else this.currentHistorySnapshotIndex -= 1

		this.refreshHistoryValues()
		Client.game.sound.play(Constants.SOUNDS.BUTTON_PRESS, { volume: 0.45 * effectsVolume });
	}

	public PreviousHistorySnapshot(): void {
		if (this.setup.GameHistory.length == 0) return

		this.currentHistorySnapshotIndex += 1
		if (this.currentHistorySnapshotIndex == this.setup.GameHistory.length) this.currentHistorySnapshotIndex = this.setup.GameHistory.length - 1

		this.refreshHistoryValues()
		Client.game.sound.play(Constants.SOUNDS.BUTTON_PRESS, { volume: 0.45 * effectsVolume });
	}

	public showHistoryReplay(customNumber:number = null): void {
		if (!this.IsSpectator && (this.betsCommited || virtualWheel) && !this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.CANNOT_SHOW_HISTORY), MESSAGE_SEVERITY_LEVEL.NOTICE);
			this.historyShown = false;
			return;
		}

		if (!this.IsSpectator && (!this.lastGameSnapshot || this.lastGameSnapshot.data.gameID == 0)) //we get this from init if there is no played game whatsoever.
		{
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NO_PLAYED_GAME_HISTORY), MESSAGE_SEVERITY_LEVEL.NOTICE);
			this.historyShown = false;
			return;
		}

		if (customNumber !== null)
			this.currentHistorySnapshotIndex = customNumber;
		else
			this.currentHistorySnapshotIndex = this.setup.GameHistory.length - 1;


		if (!this.IsSpectator && !virtualWheel)
			this.sendBets(); // send the bets that we have

		this.historyShown = true;
		this.hadTrackOpenBeforeHistory = !this.IsBoard;

		this.OnChangePhase(Phase.SHOWING_HISTORY_REPLAY);

		this.refreshHistoryValues();

		Client.remote.RemoteActionsHaveChanged();
	}

	public isGameInHistory(id:number): number {
		return this.setup.GameHistory.findIndex(game => game.data.gameID === id);
	}

	public hideHistoryReplay(): void {
		if (this.IsSpectator)
			return;

		this.checkAndToggleBoardView(this.currentGameSnapshot.data.bets, this.hadTrackOpenBeforeHistory ? BetCompatibility.TRACK : BetCompatibility.BOARD);
		// this.CopyBetsToBetTable(this.currentGameSnapshot.data.bets);
		// Client.game.events.emit(Constants.EVENTS.PLACE_BET)

		//show history state stuff
		//1.)gameID
		//gameID updated automatically from GameID getter function.
		//2.)balance
		this.balanceManager.SetCredit(this.currentGameState.Balance);

		//current win and current win number.
		this.lastWin = this.storedLastWin;
		this.jackpotWin = 0;

		Client.game.events.emit(Constants.EVENTS.PANEL_UPDATE_BALANCE, false);
		this.phase = this.currentGameState.phase;
		this.OnChangePhase(this.currentGameState.phase);
		if (this.currentGameState.totalTime != 0 && !virtualWheel)
			Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, this.currentGameState.timeLeft / this.currentGameState.totalTime, true)

		// Used to reset the pre-highlighted winning number
		Client.game.events.emit(Constants.EVENTS.WIN_NUMBER, -1);

		if (this.currentGameState.phase == Phase.READING_WIN_NUMBER_STATE)
			this.winNumberReceived(this.currentGameState.winNumber)
		else
			Client.game.events.emit(Constants.EVENTS.WIN_NUMBER, -1);

		this.historyShown = false;
		Client.game.events.emit(Constants.EVENTS.PLACE_BET);

		Client.game.events.emit(Constants.EVENTS.RENDER_HISTORY_VIEW, false);

		Client.remote.RemoteActionsHaveChanged();
	}

	private refreshHistoryValues(): void {
		this.lastGameSnapshot = deepCopy(this.setup.GameHistory[this.currentHistorySnapshotIndex])

		if (this.lastGameSnapshot) {
			this.checkAndToggleBoardView(this.lastGameSnapshot.data.bets)

			this.balanceManager.SetCredit(new DefaultBalance(this.lastGameSnapshot.balance.before).Subtract(this.lastGameSnapshot.totalBet));
			Client.game.events.emit(Constants.EVENTS.PANEL_UPDATE_BALANCE, false);

			Client.game.events.emit(Constants.EVENTS.WIN_NUMBER, -1);
			let showWinNum = -1;
			if (this.lastGameSnapshot.randoms.length) {
				showWinNum = this.lastGameSnapshot.randoms[0];
			}
			Client.game.events.emit(Constants.EVENTS.WIN_NUMBER, showWinNum);
			
			this.lastWin = this.balanceManager.GetCreditFromArray(this.lastGameSnapshot.totalWin);

			this.jackpotWin = 0;
			this.lastGameSnapshot.transactions.forEach(transaction => {
				if (transaction.source == TransactionSource.Jackpot) {
					this.jackpotWin += this.balanceManager.GetCreditFromArray(transaction.credits);
				}
			});
			Client.game.events.emit(Constants.EVENTS.PLACE_BET);
			Client.game.events.emit(Constants.EVENTS.RENDER_HISTORY_VIEW, true);
		}
		else
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NO_PLAYED_GAME_HISTORY), MESSAGE_SEVERITY_LEVEL.NOTICE);
	}

	GameRecovery(): void {
		this.checkAndToggleBoardView(this.currentGameSnapshot.data.bets)
		this.CopyBetsToBetTable(this.currentGameSnapshot.data.bets);
		this.betPresets = deepCopy(this.currentGameSnapshot.data.betPresets);//also clone presets
		Client.game.events.emit(Constants.EVENTS.PLACE_BET);
		this.betsCommited = true

		if (this.currentGameState.phase == Phase.READING_WIN_NUMBER_STATE)
			this.winNumberReceived(this.currentGameState.winNumber);
		else
			Client.game.events.emit(Constants.EVENTS.WIN_NUMBER, -1);
	}

	public UpdateEntireHistory(numbers: any): void {
		this.currentGameState.SetHistoryNumbers(numbers);
		Client.game.events.emit(Constants.EVENTS.HISTORY_UPDATE, numbers);
	}

	private AddNumberToHistory(num: number[]): void {
		let numbersToUse = this.currentGameState.HistoryNumbers;

		if (numbersToUse.length == Client.logic.setup.MaxHistorySize) {
			numbersToUse.pop();
		}

		numbersToUse.unshift(num);
		this.currentGameState.SetHistoryNumbers(numbersToUse);

		Client.game.events.emit(Constants.EVENTS.HISTORY_UPDATE_NUMBER, num);
	}

	public OnUpdateGameId(newId: number): void {
		this.ChipCountOrLimitsAllowsBetting = true;

		if (newId != 0) { // new game was opened!
			this.bets.ClearAllBets(false, this.playerPlayedFigures);
			this.undoRedo.ClearUndoSnapshots()
			Client.game.events.emit(Constants.EVENTS.PLACE_BET)
			this.betsCommited = false;
			this.isEmpty = true;
			this.currentGameState.Transactions = [];
			this.currentGameSnapshot = this.newSnapshot();
			this.currentGameState.ID = newId;
			this.currentGameSnapshot.data.gameID = newId;
		}
	}

	public VirtualWheelClearBets(): void {
		this.bets.ClearAllBets(false, this.playerPlayedFigures);
		this.undoRedo.ClearUndoSnapshots();
		Client.game.events.emit(Constants.EVENTS.PLACE_BET)
		this.betsCommited = false;
		this.isEmpty = true;
		this.currentGameSnapshot = this.newSnapshot();
	}

	public OnGameEndEvent(data: any): void {
		if (Constants.DEVELOPER_MODE)
			return;

		console.log("Game end event recieved")
		console.log(data);

		this.currentGameState.Balance = data.round.balance.after;
		this.currentGameSnapshot.balance.after = data.round.balance.after;
		this.currentGameSnapshot.totalWin = data.round.totalWin;

		this.currentGameSnapshot.endT = Date.now();

		if (this.balanceManager.GetCreditFromArray(this.currentGameSnapshot.totalBet) > 0) {
			
			if (this.setup.playboardMode == PlayboardMode.LESFIGURES_PLUS && this.figureBets) {
				this.playerPlayedFigures = false;
				for (let y = 0; y < 9; y++) {
					this.figureBets[y] = this.currentGameSnapshot.data.bets[26][y].visible;
					if (this.currentGameSnapshot.data.bets[26][y].visible > 0) {
						this.playerPlayedFigures = true;
					}
				}
			}

			this.currentGameSnapshot.data.betPresets = this.betPresets;
			this.lastGameSnapshot = deepCopy(this.currentGameSnapshot);
			this.setup.GameHistory.push(deepCopy(this.lastGameSnapshot));
			this.currentHistorySnapshotIndex = this.setup.GameHistory.length - 1;
			Client.game.events.emit(Constants.EVENTS.HISTORY_SAVED, this.lastGameSnapshot.data.gameID);//this game is guaranteed to be in history
		}

		if (this.phase != Phase.SHOWING_HISTORY_REPLAY) {
			if (this.BetSum > 0) {
				this.storedLastWin = this.balanceManager.GetCreditFromArray(data.round.totalWin);
				this.storedLastBet = this.BetSum
				if (this.Phase != Phase.SHOWING_HISTORY_REPLAY)
					this.lastWin = this.storedLastWin;
			}
			this.balanceManager.SetCredit(data.round.balance.after);
		}
	}

	private OnWinEvent(data: any): void {
		// console.log("Win event recieved")
		// console.log(data);
		return;
	}

	public OnUpdateProgressBar(timeLeft: any): void {
		if (!this.mainSceneReady || virtualWheel)
			return;

		if (this.currentGameState.totalTime == 0)
			Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, 0);
		else
			Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, timeLeft / this.currentGameState.totalTime);
	}

	public onUpdateSendBetsTime(time: number): void {
		if (!this.mainSceneReady)
			return;

		this.currentGameState.timeLeft = time;

		if (this.phase == Phase.SHOWING_HISTORY_REPLAY) return;

		if (this.currentGameState.timeLeft <= 1000 && !this.firstSendBetLock && this.currentGameState.timeLeft >= 0) {
			this.sendBets();
			this.firstSendBetLock = true;
		}
	}

	public checkAndToggleBoardView(table?: { visible: number, hidden: number }[][], fallbackTo: BetCompatibility = BetCompatibility.BOTH): void {
		let compatibleWith = this.bets.CheckBetsBoardCompatibility(table);
		if (compatibleWith == BetCompatibility.BOTH) {
			compatibleWith = fallbackTo;
		}
		//toggle rigth view (board / track)
		if ((compatibleWith == BetCompatibility.TRACK && this.IsBoard) || (compatibleWith == BetCompatibility.BOARD && !this.IsBoard))
			Client.game.events.emit(Constants.EVENTS.TOGGLE_BOARD_TRACK_VIEW);
	}

	GetCurrentBetField(): BetField {
		if (this.bets.checkBet(this.CurrBetX, this.CurrBetY))
			return this.bets.Fields[this.CurrBetX][this.CurrBetY];
		else
			return null;
	}

	SetCurrentBet(x: number, y: number) {
		this.CurrBetX = x;
		this.CurrBetY = y;
	}

	IsDoubleZero(): boolean {
		return this.DoubleZero;
	}

	public PlacePreset(preset: PresetType, bet: number = null, ignoreUndoPoint: boolean = false): void {
		//debug log
		//console.log(preset + " preset was requested, this preset covers "+JSON.stringify(this.betPresets.get(preset)));

		if (this.lockBetting)
			return;

		if (!this.BetsAllowed) {
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.BETS_ARE_CLOSED), MESSAGE_SEVERITY_LEVEL.NOTICE);
			return;
		}

		//count over the chip limit right here and return if over max
		if (this.bets.FieldLimitsEnabled) {
			let newChipsToPlace: number = 0;
			this.betPresets.get(preset).fields.forEach((field) => {
				if (this.bets.Fields[field.X][field.Y].BetCredit == 0)
					newChipsToPlace++;
			});

			if (this.bets.CountChipsOnPlayboard() + newChipsToPlace > this.bets.getStake().BetsCountMax && this.bets.getStake().BetsCountMax > 0) {
				console.log("Cannot place the chip: Max number of chips on the table reached!")
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.MAX_NUM_CHIPS_REACHED), MESSAGE_SEVERITY_LEVEL.NOTICE)
				Client.logic.AreBetsAllowedByLimits = false;
				return;
			}
		}

		let BetsNow = this.bets.Count();

		if (!ignoreUndoPoint)
			this.undoRedo.AddUndoPoint();

		let betCredit;//our bet for 1 field , if -1 it is max

		if (!bet)
			betCredit = this.Bet;
		else
			betCredit = bet;

		let creditsLeft = this.balanceManager.GetCredit() - this.bets.Count();//credits left at this moment

		betCredit = this.CanPlacePreset(this.betPresets.get(preset).fields, betCredit, creditsLeft);

		//TODO: also check win limits
		if (betCredit > 0) {
			//total bet required for this preset
			let totalBet = betCredit * this.getPresetChipAmount(this.betPresets.get(preset).fields);

			//console.log("calculating for playboard limit, BetsNow " + BetsNow + " totalBet " + totalBet + " creditsLeft " + creditsLeft);
			//check playboard max limit
			if (this.bets.FieldLimitsEnabled && this.bets.getStake().PlayBoardLimitMax > 0 && this.bets.getStake().PlayBoardLimitMax - (BetsNow + totalBet) < 0) {
				console.log("Playboard limit reached!")
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.PLAYBOARD_LIMIT_REACHED), MESSAGE_SEVERITY_LEVEL.NOTICE)
				Client.logic.AreBetsAllowedByLimits = false;
				return;
			}

			//do we have enough money for that ?
			if (totalBet <= creditsLeft) {
				//all is good place the bets as hidden for all fields in this preset
				this.betPresets.get(preset).fields.forEach((field) => {
					this.bets.Fields[field.X][field.Y].HiddenCredit += betCredit * field.A;
					//console.log("x: "+field.X+",y:"+field.Y+" hidden credits added "+betCredit+" , new total : "+this.bets.Fields[field.X][field.Y].HiddenCredit);
				});

				this.betPresets.get(preset).bet += totalBet;

				this.isEmpty = false;
				this.betsChanged = true;
				Client.game.events.emit(Constants.EVENTS.PLACE_BET);

				if (!virtualWheel) {
					this.sendBets(ignoreUndoPoint);
				} else {
					Client.game.events.emit(Constants.EVENTS.VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON, this.bets.CountChipsOnPlayboard() > 0);
				}
			} else {
				if (!ignoreUndoPoint)
					this.undoRedo.ClearLastUndo();
				//display not enough credits message
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.NOT_ENOUGH_CREDITS), MESSAGE_SEVERITY_LEVEL.NOTICE);
				return;
			}
		} else {
			if (!ignoreUndoPoint)
				this.undoRedo.ClearLastUndo();

			if (betCredit == -1) {
				console.log("field not enabled or invalid field");
			}
			else if (betCredit == -2) {
				console.log("playboard limit reached");
			}
			else {
				console.log("field limit reached");
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.FIELD_LIMIT), MESSAGE_SEVERITY_LEVEL.NOTICE, false, Client.game.input.activePointer.worldX, Client.game.input.activePointer.worldY);
			}
		}

		Client.game.events.emit(Constants.EVENTS.PLACE_BET);
	}

	//for each bet preset covers, check if we can place a bet on it by looking at minimum and maximum field limit and return what is placable if all can be placed
	public CanPlacePreset(fields: PresetCoordinate[], betToPlace: number, creditsLeft:number): number {
		let whatCanWePlace: number = 0;
		let min: number = -1;
		let max: number = -1;
		let biggestMax:number = -1;
		let maxChipPerField: number = 0;
		let totalChipCount: number = 0;

		//first get highest min, lowest max and biggest amount of chips we must place
		fields.forEach((field) => {
			//do invalid field check just once, immediatley throw errors if invalid
			if (!this.bets.checkBet(field.X, field.Y)) {
				whatCanWePlace = -1;
				return;
			}
			if (!this.bets.Fields[field.X][field.Y].FieldEnabled) {
				whatCanWePlace = -1;
				return;
			}
			//---------------------------------------------------------------------

			let _min: number = Math.max(1, this.bets.GetMinimalLimit(field.X, field.Y) - (this.bets.Fields[field.X][field.Y].BetCredit + this.bets.Fields[field.X][field.Y].HiddenCredit));
			let _max: number = this.bets.GetMaximalLimit(field.X, field.Y);

			if (_max == 0) {//if field has no max, apply plaboard max
				_max = Math.max(0, this.Stake.PlayBoardLimitMax);
			}

			if(_max != 0)//field has a max limit
			{
				//lower max by what is already placed on this field
				_max -= (this.bets.Fields[field.X][field.Y].BetCredit + this.bets.Fields[field.X][field.Y].HiddenCredit);

				if (_max < 1)//if it is lower than 1, we can't place anything
					return whatCanWePlace = -3;//field limit reached
			}

			if (min == -1)
				min = _min
			else
				min = Math.max(min, (_min/field.A));

			if (max == -1)
				max = _max
			else
				max = Math.min(max, _max/field.A);

			if (biggestMax == -1)
				biggestMax = _max
			else
				biggestMax = Math.max(biggestMax, _max);

			maxChipPerField = Math.max(maxChipPerField, field.A);
			totalChipCount += field.A;
		});

		if (whatCanWePlace < 0)
			return whatCanWePlace;

		//console.log("trying to place a bet sized on preset " + whatCanWePlace);
		//console.log("min: " + min + " max: " + max + " maxChipPerField: " + maxChipPerField + " totalChipCount: " + totalChipCount);

		//we have min, max , chip count,.. now calculate bet to place----------------------------

		if (betToPlace == -1)// max bet
		{
			whatCanWePlace = max == 0 ? Math.floor(creditsLeft / totalChipCount) : biggestMax;
		}
		else
			whatCanWePlace = betToPlace * maxChipPerField;

		if (max == 0)//limitless bet
		{
			if (betToPlace == -1)
				whatCanWePlace = Math.floor(creditsLeft / totalChipCount);
		}
		else// has limits,and we will apply them
		{
			whatCanWePlace = Math.min(Math.max(min, whatCanWePlace), max);
		}

		if (whatCanWePlace == 0 && max != 0) {
			//Field limit reached!
			return -2;
		}

		return Math.ceil(whatCanWePlace / maxChipPerField);//must be ceil otherwise we will get sub min bets if decimal places like min 3 and bet 2 chips
	}

	public getPresetChipAmount(fields: PresetCoordinate[]): number {
		let ret: number = 0;
		fields.forEach((field) => {
			ret += field.A;
		});
		return ret;
	}

	protected OnCommitBets: IMAXAMessageCallback = (_ok: boolean, msg: IMAXAServerMessage) => {
		//console.log("OnCommitBets response : "+JSON.stringify(msg));
		if (_ok) {
			// console.log("Commit bets success");
			if (virtualWheel) {
				this.currentGameSnapshot.data.bets = deepCopyServerBetsArrayToRouletteHistoryArray(msg.payload.bets as number[][], msg.payload.betPresets);

				for (const [key, value] of Object.entries(msg.payload.betPresets)) {
					this.betPresets.get(key).bet = (value as number) * this.getPresetChipAmount(this.betPresets.get(key).fields);
				}
				this.currentGameSnapshot.data.betPresets = deepCopy(this.betPresets);

				this.betsCommited = this.bets.CountFromGivenBetArray(this.currentGameSnapshot.data.bets) > 0;
			}
			else {
				this.currentGameSnapshot.data.bets = deepCopyServerBetsArrayToRouletteHistoryArray(msg.payload.bets as number[][], msg.payload.betPresets);

				for (const [key, value] of Object.entries(msg.payload.betPresets)) {
					this.betPresets.get(key).bet = (value as number) * this.getPresetChipAmount(this.betPresets.get(key).fields);
				}
				this.currentGameSnapshot.data.betPresets = deepCopy(this.betPresets);

				this.betsCommited = this.bets.CountFromGivenBetArray(this.currentGameSnapshot.data.bets) > 0;

				if (this.sendBetsImmediateRequested && msg.contextID == this.sendBetsImmediateRequestedContext) {
					this.sendBetsImmediateRequested = false;
					if (this.betsChanged)
						this.sendBets(true);
				}
			}
		} else {
			if (this.betsCommited) {
				//revert
				this.CopyBetsToBetTable(this.currentGameSnapshot.data.bets);
				this.betPresets = deepCopy(this.currentGameSnapshot.data.betPresets);

				Client.game.events.emit(Constants.EVENTS.PLACE_BET);
			}
			else
				this.ClearAllBetsOnError();

			if (msg) {
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, msg.payload.message, MESSAGE_SEVERITY_LEVEL.WARNING);  //user visible error
			} else {
				//There is no message we have nothing to display
			}
		}

		if (virtualWheel) {
			Client.game.events.emit(Constants.EVENTS.VIRTUAL_WHEEL_RESPONSE, _ok, msg);
		}
	}

	TogglePaintMode(): void {
		this.paintModeEnabled = !this.paintModeEnabled;
	}

	private ClearAllBetsOnError(): void {
		this.bets.ClearAllBets();
		this.isEmpty = true;
		this.undoRedo.ClearUndoSnapshots();
		Client.game.events.emit(Constants.EVENTS.PLACE_BET);
	}

	OnHistoryButtonClicked(customNumber:number = null): boolean {
		if (Date.now() < this.lastTimeHistoryClicked + 500) {
			return;
		}

		Client.game.sound.play(Constants.SOUNDS.BUTTON_PRESS, { volume: 0.45 * effectsVolume });
		this.lastTimeHistoryClicked = Date.now();

		if (this.historyShown)
			this.hideHistoryReplay();
		else
			this.showHistoryReplay(customNumber);

		return this.historyShown;
	}

	OnRequestPayoutClicked(): void {
		if (!this.setup.USER.PayoutEnabled || this.BetSum > 0)
			return;

		this.payoutRequested = true;
		setTimeout(function () { this.payoutRequested = false; }.bind(this), 2000);
		Client.remote.SendRequest(Constants.CLIENT_REQUESTS.PAYOUT, null, (_ok, data) => { })
	}

	public OnLogoutClicked(successfulLogoutCallback?: () => void): void {
		if (!this.setup.USER.LogoutSupported)
			return

		Client.remote.SendRequest(Constants.CLIENT_REQUESTS.LOGOUT, null, (_ok, data) => {
			if (_ok) {
				this.phase = Phase.ERROR_OR_DISCONNECTED;
				this.ClearAllBetsOnError();
				Client.remote.DisconnectSocket();

				if (Client.slot) {
					window.location.href = 'igp://close';
				}
				else {
					window.postMessage('closeGame', '*');
					window.parent.postMessage('closeGame', '*');
				}

				setTimeout(() => {
					try {
						let retVal = GetParameterByName("ret");
						if (retVal && retVal.length > 1)
							window.open(retVal, "_self")
						else if (window.history.length > 2)
							window.history.back()
					}
					catch (e) { }
				}, 2000);

				successfulLogoutCallback();
			} else {
				if (data && data.payload) Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, data.payload.message, MESSAGE_SEVERITY_LEVEL.NOTICE);
			}
		})
	}

	public ClickedOnExit(): void {
		if (this.Bet > 0)
			this.sendBets(true);

		if (!Client.exiting && this.canRequestExit) {
			this.canRequestExit = false;
			Client.remote.SendRequest(Constants.CLIENT_REQUESTS.EXIT, null, null);
		}
	}

	public CancelExit(): void {
		Client.exiting = false;
		clearInterval(this.exitingInterval);
	}

	public GameExit(): void {
		Client.exiting = true;

		this.exitingInterval = setInterval(() => {
			Client.game.events.emit(Constants.EVENTS.AUTO_RESOLVE, null);//request to autoresolve all player required inputs
			if (this.BetSum == 0 && (this.setup.playboardMode == PlayboardMode.NORMAL || ((this.setup.playboardMode == PlayboardMode.LESFIGURES_PLUS || this.setup.playboardMode == PlayboardMode.LESFIGURES) && !this.playerPlayedFigures && this.playerPromptsWaiting == 0))) {
				Client.remote.SendRequest(Constants.CLIENT_REQUESTS.GOODBYE, true, null);
				setTimeout(() => {
					if (Client.slot) {
						window.location.href = 'igp://close';
					}
					else {
						window.postMessage('closeGame', '*');
						window.parent.postMessage('closeGame', '*');

						setTimeout(() => { history.back() }, 1000);
					}
				}, 500);
				clearInterval(this.exitingInterval);
			}
		}, 2000);
	}

	//current valid flags : "win" , "freespinDialog", "gambleDialog" , "helpscreen"
	public UpdateFlags(add: boolean, name: String, handleUpdateState: boolean = true): void {
		if (!Client.slot)
			return;

		if (add) {
			if (this.flags.indexOf(name) == -1) {
				this.flags.push(name);
				if (handleUpdateState)
					this.HandleChangedState(true);
			}
		} else {
			if (this.flags.indexOf(name) != -1) {
				this.flags.splice(this.flags.indexOf(name), 1);
				if (handleUpdateState)
					this.HandleChangedState(true);
			}
		}
	}


	public HandleChangedState(flagsChanged: boolean = false, overrideState: IMAXAState | null = null): void {
		if (!Client.slot)
			return;

		let state = this.imaxaState;
		
		if(overrideState!=null)
			state = overrideState;

		if (this.previous_imaxaState != state || this.previous_imaxaSubState != this.imaxaSubState || flagsChanged) {
			this.previous_imaxaSubState = this.imaxaSubState;
			this.previous_imaxaState = state;

			let status = {
				"state": state,
				"subState": this.imaxaSubState,
				"flags": this.flags
			}

			Client.remote.RemoteActionsHaveChanged();
			Client.remote.SendRequest(Constants.CLIENT_REQUESTS.CLIENT_STATUS, status, null);
			//console.log("Sending new states : " + state + " , substate: " + this.imaxaSubState + " , with flags " + JSON.stringify(this.flags));
			this.UpdateFlags(false, "win", false);
		}
	}
}

export class UndoRedo {
	constructor(private logic: Logic) {

	}

	AddUndoPoint(): void {
		this.actions.push({table: this.logic.getCurrentBetsAsArray(), presets: deepCopy(Client.logic.betPresets)})

		if (Client.logic.previousBet == 0 && Client.logic.Bet > 0 || Client.logic.Bet == 0 && Client.logic.previousBet != 0) {
			Client.remote.RemoteActionsHaveChanged();
		}
		Client.logic.previousBet = Client.logic.Bet;
	}

	Undo(): boolean {
		if (this.actions.length > 0) {
			let previousAction = this.actions.pop();
			this.logic.betPresets = deepCopy(previousAction.presets);
			this.logic.CopyBetsToBetTable(previousAction.table);

			if (Client.logic.previousBet == 0 && Client.logic.Bet > 0 || Client.logic.Bet == 0 && Client.logic.previousBet != 0) {
				Client.remote.RemoteActionsHaveChanged();
			}
			Client.logic.previousBet = Client.logic.Bet;

			return true;
		}
		return false;
	}

	ClearLastUndo(): void {
		this.actions.pop();
	}

	ClearUndoSnapshots(): void {
		this.actions.length = 0;
		Client.logic.previousBet = 0;
	}

	public actions = new Array()
}